angular.module("ainapp")
    .controller("InitController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", "LanguageService", "$timeout", "RecurrenceService", "$q",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window, LanguageService, $timeout, RecurrenceService, $q) {

            // Phase 1: Email Template Migration - Initialize window object
            if (typeof window !== 'undefined') {
                window.MagtecEmailTemplateTypes = window.MagtecEmailTemplateTypes || [];
            }

            $scope.tryPrintPOS = function () {

                qz.api.setSha256Type(function (data) {
                    return sha256(data);
                });

                qz.websocket.connect().then(function (res) {
                    console.log("Connected!");
                });

                var config = qz.configs.create("POS", {
                    encoding: "CP864"
                });

                var data = [
                    '\x1B' + '\x40', //init command - necessary for proper byte interpretation
                    '\x1B' + '\x74' + '\x25', // Setup "codepage 37", which is Epson's IBM864

                    // UTF-8 Arabic "Lorem Ipsum" text from http://istizada.com/arabic-lorem-ipsum/
                    'لكن لا بد أن أوضح لك أن كل هذه الأفكار', '\n',
                    'المغلوطة حول استنكار  النشوة وتمجيد', '\n',
                    'الألم نشأت بالفعل، وسأعرض لك التفاصيل', '\n',
                    'لتكتشف حقيقة وأساس تلك السعادة', '\n',
                    'البشرية، فلا أحد يرفض أو يكره أو يتجنب', '\n',
                    'الشعور بالسعادة، ولكن بفضل هؤلاء', '\n',
                    'الأشخاص الذين لا يدركون بأن السعادة', '\n',
                    'لا بد أن نستشعرها بصورة أكثر عقلانية', '\n',
                    'ومنطقية فيعرضهم هذا لمواجهة الظروف', '\n',
                    'الأليمة، وأكرر بأنه لا يوجد من يرغب في', '\n',
                    'الحب ونيل المنال ويتلذذ بالآلام، الألم', '\n',
                    'هو الألم ولكن نتيجة لظروف ما قد تكمن', '\n',
                    'السعاده فيما نتحمله من كد وأسي.', '\n',
                    '\n\n\n\n'
                ];

                qz.print(config, data);

                //                qz.print(config, data).catch(function (err) {
                //                    console.log(err);
                //                });
            }

            $scope.istoggle = false;
            $scope.togglehamburger = function () {
                $('#main-wrapper').toggleClass("menu-toggle");
                $(".hamburger").toggleClass("is-active");
                $scope.istoggle = !$scope.istoggle;
            }

            $scope.toggleView = false;
            $scope.switchSideMenu = function () {
                $('#main-wrapper').toggleClass("menu-toggle");
                $(".hamburger").toggleClass("is-active");
                $scope.istoggle = !$scope.istoggle;
            }
            $scope.toggle = function () {
                $('#main-wrapper').toggleClass("menu-toggle");
                $(".hamburger").toggleClass("is-active");
                $scope.istoggle = !$scope.istoggle;
            }

            $scope.toggle2 = function (val) {
                if (val == true) {
                    $('#main-wrapper').toggleClass("menu-toggle");
                    $(".hamburger").toggleClass("is-active");
                    $scope.istoggle = !$scope.istoggle;
                }
            }

            $scope.GoTableDesign = function () {
                $state.go("TableDesign", { VoucherType: "Material Request" })
            }

            $scope.basePath = config.basePath;

            MainService.ClearTempData();
            MainService.SendBirthdayMail();
            MainService.SendDocumentExpiryMail();

            $scope.IconArray = [
                {
                    Name: "balance",
                    Path: "images/icons/balance.png"
                }, {
                    Name: "balance 2",
                    Path: "images/icons/balance2.png"
                }, {
                    Name: "batch",
                    Path: "images/icons/batch.png"
                }, {
                    Name: "card 1",
                    Path: "images/icons/card1.png"
                }, {
                    Name: "card 2",
                    Path: "images/icons/card2.png"
                }, {
                    Name: "cheque 1",
                    Path: "images/icons/cheque1.png"
                }, {
                    Name: "cheque 2",
                    Path: "images/icons/cheque2.png"
                }, {
                    Name: "expense",
                    Path: "images/icons/expense.png"
                }, {
                    Name: "ledger 1",
                    Path: "images/icons/ledger1.png"
                }, {
                    Name: "ledger 2",
                    Path: "images/icons/ledger2.png"
                }, {
                    Name: "list",
                    Path: "images/icons/list.png"
                }, {
                    Name: "movement",
                    Path: "images/icons/movement.png"
                }, {
                    Name: "note 1",
                    Path: "images/icons/note1.png"
                }, {
                    Name: "note 2",
                    Path: "images/icons/note2.png"
                }, {
                    Name: "note 3",
                    Path: "images/icons/note3.png"
                }, {
                    Name: "opening stock",
                    Path: "images/icons/openingstock.png"
                }, {
                    Name: "payment 1",
                    Path: "images/icons/payment1.png"
                }, {
                    Name: "payment 2",
                    Path: "images/icons/payment2.png"
                }, {
                    Name: "payment 3",
                    Path: "images/icons/payment3.png"
                }, {
                    Name: "payment 4",
                    Path: "images/icons/payment4.png"
                }, {
                    Name: "stock",
                    Path: "images/icons/stock.png"
                }, {
                    Name: "stock 2",
                    Path: "images/icons/stock2.png"
                }, {
                    Name: "stock 3",
                    Path: "images/icons/stock3.png"
                }, {
                    Name: "stock FOC",
                    Path: "images/icons/stockFOC.png"
                }, {
                    Name: "stock Issue",
                    Path: "images/icons/stockIssue.png"
                }, {
                    Name: "stock JV",
                    Path: "images/icons/stockJV.png"
                }, {
                    Name: "stock Receive",
                    Path: "images/icons/stockReceive.png"
                }, {
                    Name: "valuation",
                    Path: "images/icons/valuation.png"
                }, {
                    Name: "warehouse",
                    Path: "images/icons/warehouse.png"
                }, {
                    Name: "warehouse 2",
                    Path: "images/icons/warehouse2.png"
                }
            ];

            $scope.monthsPlainArr = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ];

            $scope.DaysArr = [
                {
                    Name: ""
                },
                {
                    Name: "Monday"
                },
                {
                    Name: "Tuesday"
                },
                {
                    Name: "Wednesday"
                },
                {
                    Name: "Thursday"
                },
                {
                    Name: "Friday"
                },
                {
                    Name: "Saturday"
                },
                {
                    Name: "Sunday"
                },
            ];

            $scope.MonthsArr = [
                {
                    Name: "January"
                },
                {
                    Name: "February"
                },
                {
                    Name: "March"
                },
                {
                    Name: "April"
                },
                {
                    Name: "May"
                },
                {
                    Name: "June"
                },
                {
                    Name: "July"
                },
                {
                    Name: "August"
                },
                {
                    Name: "September"
                },
                {
                    Name: "October"
                },
                {
                    Name: "November"
                },
                {
                    Name: "December"
                },
            ];

            $scope.MonthsArr2 = [
                {
                    Name: "January",
                    Id: 1
                },
                {
                    Name: "February",
                    Id: 2
                },
                {
                    Name: "March",
                    Id: 3
                },
                {
                    Name: "April",
                    Id: 4
                },
                {
                    Name: "May",
                    Id: 5
                },
                {
                    Name: "June",
                    Id: 6
                },
                {
                    Name: "July",
                    Id: 7
                },
                {
                    Name: "August",
                    Id: 8
                },
                {
                    Name: "September",
                    Id: 9
                },
                {
                    Name: "October",
                    Id: 10
                },
                {
                    Name: "November",
                    Id: 11
                },
                {
                    Name: "December",
                    Id: 12
                },
            ];

            var tdate = new Date();
            var year = tdate.getFullYear();

            $scope.YearsArr = [];

            var yr1 = {
                Name: year - 3
            }
            $scope.YearsArr.push(yr1);

            var yr2 = {
                Name: year - 2
            }
            $scope.YearsArr.push(yr2);

            var yr3 = {
                Name: year - 1
            }
            $scope.YearsArr.push(yr3);

            var yr4 = {
                Name: year
            }
            $scope.YearsArr.push(yr4);

            var yr5 = {
                Name: year + 1
            }
            $scope.YearsArr.push(yr5);

            var yr6 = {
                Name: year + 2
            }
            $scope.YearsArr.push(yr6);

            var yr7 = {
                Name: year + 3
            }
            $scope.YearsArr.push(yr7);


            $scope.PageList = [

                //----------DASHBOARD-----------

                {
                    Category: "Dashboard",
                    Pages: [
                        {
                            Name: "Dashboard",
                            Type: "Dashboard",
                            Link: "home",
                        },
                        {
                            Name: "Financial Dashboard",
                            Type: "Dashboard",
                            Link: "financialDash",
                        },
                        {
                            Name: "Purchase Dashboard",
                            Type: "Dashboard",
                            Link: "purchaseDash",
                        },
                        {
                            Name: "Sales Dashboard",
                            Type: "Dashboard",
                            Link: "salesDash",
                        },
                        {
                            Name: "Broker Dashboard",
                            Type: "Dashboard",
                            Link: "brokerDash",
                        },
                        {
                            Name: "Realestate Dashboard",
                            Type: "Dashboard",
                            Link: "realestateDash",
                        },
                        {
                            Name: "HR Dashboard",
                            Type: "Dashboard",
                            Link: "hrDash",
                        },
                        {
                            Name: "Pending Sales Dashboard",
                            Type: "Dashboard",
                            Link: "pendingSalesDash",
                        },
                        {
                            Name: "Pending Purchase Dashboard",
                            Type: "Dashboard",
                            Link: "pendingPurchaseDash",
                        },
                    ]
                },
                {
                    Category: "Masters",
                    Pages: [
                        {
                            Name: "Status",
                            Type: "Masters",
                            Link: "status",
                        },
                        {
                            Name: "Bank",
                            Type: "Masters",
                            Link: "bank",
                        },
                        {
                            Name: "Department",
                            Type: "Masters",
                            Link: "Department",
                        },
                        {
                            Name: "Designation",
                            Type: "Masters",
                            Link: "Designation",
                        },
                        {
                            Name: "Country",
                            Type: "Masters",
                            Link: "Country",
                        },
                        {
                            Name: "City",
                            Type: "Masters",
                            Link: "City",
                        },
                        {
                            Name: "Unit",
                            Type: "Masters",
                            Link: "Unit",
                        },
                        {
                            Name: "Unit Convertion",
                            Type: "Masters",
                            Link: "UnitConvertion",
                        },
                        {
                            Name: "VAT",
                            Type: "Masters",
                            Link: "VAT",
                        },
                        {
                            Name: "Currency",
                            Type: "Masters",
                            Link: "Currency",
                        },
                        {
                            Name: "Currency Convertion",
                            Type: "Masters",
                            Link: "CurrencyConvertion",
                        },
                        {
                            Name: "Branch",
                            Type: "Masters",
                            Link: "branch",
                        },
                        {
                            Name: "Warehouse",
                            Type: "Masters",
                            Link: "warehouse",
                        },
                        {
                            Name: "Brand",
                            Type: "Masters",
                            Link: "brand",
                        },
                        {
                            Name: "Cusian",
                            Type: "Masters",
                            Link: "Cusian",
                        },
                        {
                            Name: "Recipe",
                            Type: "Masters",
                            Link: "recipe",
                        },
                        {
                            Name: "User Roles",
                            Type: "Masters",
                            Link: "userRoles",
                        },
                        {
                            Name: "Master 1",
                            Type: "Masters",
                            Link: "master1",
                        },
                        {
                            Name: "Master 2",
                            Type: "Masters",
                            Link: "master2",
                        },
                        {
                            Name: "Master 3",
                            Type: "Masters",
                            Link: "master3",
                        },
                        {
                            Name: "Master 4",
                            Type: "Masters",
                            Link: "master4",
                        },
                        {
                            Name: "Master 5",
                            Type: "Masters",
                            Link: "master5",
                        },
                        {
                            Name: "Master 6",
                            Type: "Masters",
                            Link: "master6",
                        },
                        {
                            Name: "Master 7",
                            Type: "Masters",
                            Link: "master7",
                        },
                        {
                            Name: "Master 8",
                            Type: "Masters",
                            Link: "master8",
                        },

                    ]
                },
                {
                    Category: "Accounts",
                    Pages: [
                        {
                            Name: "Chart Of Accounts",
                            Type: "Accounts",
                            Link: "AccountMaster",
                        },
                        {
                            Name: "Account Cost Center",
                            Type: "Accounts",
                            Link: "AccountCostCenters",
                        },
                        {
                            Name: "Account Type",
                            Type: "Accounts",
                            Link: "AccountType",
                        },
                        {
                            Name: "Cost Center",
                            Type: "Accounts",
                            Link: "CostCenter",
                        },
                        {
                            Name: "Customers",
                            Type: "Accounts",
                            Link: "Customers",
                        },
                        {
                            Name: "Add Customer",
                            Type: "Accounts",
                            Link: "addCustomer",
                        },
                        {
                            Name: "Employees",
                            Type: "Accounts",
                            Link: "employee",
                        },
                        {
                            Name: "Add Employee",
                            Type: "Accounts",
                            Link: "addEmployee",
                        },
                        {
                            Name: "Vendors",
                            Type: "Accounts",
                            Link: "Vendors",
                        }, {
                            Name: "Add Vendor",
                            Type: "Accounts",
                            Link: "addVendor",
                        },
                        {
                            Name: "Expenses",
                            Type: "Accounts",
                            Link: "Expenses",
                        },
                    ]
                },
                {
                    Category: "Inventory",
                    Pages: [
                        {
                            Name: "Product Parent Category",
                            Type: "Inventory",
                            Link: "productParentCategory",
                        }, {
                            Name: "Product Category",
                            Type: "Inventory",
                            Link: "productCategory",
                        },
                        {
                            Name: "Product Sub Category",
                            Type: "Inventory",
                            Link: "productSubCategory",
                        },
                        {
                            Name: "Add Product",
                            Type: "Inventory",
                            Link: "products",
                        },
                        {
                            Name: "Product List",
                            Type: "Inventory",
                            Link: "productList",
                        },
                        {
                            Name: "Product Types",
                            Type: "Inventory",
                            Link: "productType",
                        },
                        {
                            Name: "Product Sizes",
                            Type: "Inventory",
                            Link: "productSize",
                        },
                        {
                            Name: "Product Color",
                            Type: "Inventory",
                            Link: "productColor",
                        },
                        {
                            Name: "Service Category",
                            Type: "Inventory",
                            Link: "serviceCategory",
                        },
                        {
                            Name: "Service Sub Category",
                            Type: "Inventory",
                            Link: "serviceSubCategory",
                        },
                        {
                            Name: "Add Service",
                            Type: "Inventory",
                            Link: "services",
                        },
                        {
                            Name: "Service List",
                            Type: "Inventory",
                            Link: "ServiceList",
                        },
                        {
                            Name: "Asset Category",
                            Type: "Inventory",
                            Link: "assetCategory",
                        },
                        {
                            Name: "Asset Sub Category",
                            Type: "Inventory",
                            Link: "assetSubCategory",
                        },
                        {
                            Name: "Add Asset",
                            Type: "Inventory",
                            Link: "assets",
                        },
                        {
                            Name: "Asset List",
                            Type: "Inventory",
                            Link: "AssetList",
                        },
                        {
                            Name: "Price Chart",
                            Type: "Inventory",
                            Link: "priceChart",
                        },
                        {
                            Name: "Substitute Product",
                            Type: "Inventory",
                            Link: "substituteProduct",
                        },
                    ]
                },
                {
                    Category: "Uploads",
                    Pages: [
                        {
                            Name: "Bulk Cost Center",
                            Type: "Masters",
                            Link: "BulkCostCenter",
                        },
                        {
                            Name: "Customer Upload",
                            Type: "Uploads",
                            Link: "CustomerUpload",
                        }, {
                            Name: "Account Upload",
                            Type: "Uploads",
                            Link: "AccountUploadController",
                        },
                        {
                            Name: "Expense Upload",
                            Type: "Uploads",
                            Link: "ExpenseUpload",
                        },
                        {
                            Name: "Vendor Upload",
                            Type: "Uploads",
                            Link: "VendorUpload",
                        },
                        {
                            Name: "Product Update",
                            Type: "Uploads",
                            Link: "productUpdate",
                        },
                        {
                            Name: "Product Upload",
                            Type: "Uploads",
                            Link: "productUpload",
                        },
                        {
                            Name: "Service Upload",
                            Type: "Uploads",
                            Link: "serviceUpload",
                        },
                        {
                            Name: "Asset Upload",
                            Type: "Uploads",
                            Link: "assetUpload",
                        },
                    ]
                },
                {
                    Category: "Purchase",
                    Pages: [
                        {
                            Name: "Add Purchase Enquiry",
                            Type: "Purchase",
                            Link: "addPurchaseEnquiry",
                        },
                        {
                            Name: "Purchase Enquiries",
                            Type: "Purchase",
                            Link: "PurchaseEnquiry",
                        },
                        {
                            Name: "Purchase Enquiry Preview",
                            Type: "Purchase",
                            Link: "viewPurchaseEnquiry",
                        },
                        {
                            Name: "Add Material Request",
                            Type: "Purchase",
                            Link: "addMaterialRequest",
                        },
                        {
                            Name: "Material Requests",
                            Type: "Purchase",
                            Link: "MaterialRequest",
                        },
                        {
                            Name: "Material Request Preview",
                            Type: "Purchase",
                            Link: "viewMaterialRequest",
                        },
                        {
                            Name: "Add Purchase Request",
                            Type: "Purchase",
                            Link: "addPurchaseRequest",
                        },
                        {
                            Name: "Purchase Requests",
                            Type: "Purchase",
                            Link: "PurchaseRequest",
                        },
                        {
                            Name: "Purchase Request Preview",
                            Type: "Purchase",
                            Link: "viewPurchaseRequest",
                        },
                        {
                            Name: "Add Purchase Quotation",
                            Type: "Purchase",
                            Link: "addPurchaseQuotation",
                        },
                        {
                            Name: "Purchase Quotations",
                            Type: "Purchase",
                            Link: "PurchaseQuotation",
                        },
                        {
                            Name: "Purchase Quotation Preview",
                            Type: "Purchase",
                            Link: "viewPurchaseQuotation",
                        },
                        {
                            Name: "Add Purchase Order",
                            Type: "Purchase",
                            Link: "addPurchaseOrder",
                        },
                        {
                            Name: "Purchase Orders",
                            Type: "Purchase",
                            Link: "PurchaseOrder",
                        },
                        {
                            Name: "Purchase Order Preview",
                            Type: "Purchase",
                            Link: "viewPurchaseOrder",
                        },
                        {
                            Name: "Add Goods Received",
                            Type: "Purchase",
                            Link: "addGoodsReceived",
                        },
                        {
                            Name: "Goods Receiveds",
                            Type: "Purchase",
                            Link: "GoodsReceived",
                        },
                        {
                            Name: "Goods Received Preview",
                            Type: "Purchase",
                            Link: "viewGoodsReceived",
                        },
                        {
                            Name: "Add Direct Purchase Invoice",
                            Type: "Purchase",
                            Link: "addDirPurchaseInvoice",
                        },
                        {
                            Name: "Direct Purchase Invoices",
                            Type: "Purchase",
                            Link: "DirPurchaseInvoice",
                        },
                        {
                            Name: "Direct Purchase Invoice Preview",
                            Type: "Purchase",
                            Link: "viewDirPurchaseInvoice",
                        },
                        {
                            Name: "Add Individual Purchase Invoice",
                            Type: "Purchase",
                            Link: "addIndPurchaseInvoice",
                        },
                        {
                            Name: "Individual Purchase Invoices",
                            Type: "Purchase",
                            Link: "IndPurchaseInvoice",
                        },
                        {
                            Name: "Individual Purchase Invoice Preview",
                            Type: "Purchase",
                            Link: "viewIndPurchaseInvoice",
                        },
                        {
                            Name: "Add Export Purchase Invoice",
                            Type: "Purchase",
                            Link: "addExpPurchaseInvoice",
                        },
                        {
                            Name: "Export Purchase Invoices",
                            Type: "Purchase",
                            Link: "ExpPurchaseInvoice",
                        },
                        {
                            Name: "Export Purchase Invoice Preview",
                            Type: "Purchase",
                            Link: "viewExpPurchaseInvoice",
                        },
                        {
                            Name: "Add Import Purchase Invoice",
                            Type: "Purchase",
                            Link: "addImpPurchaseInvoice",
                        },
                        {
                            Name: "Import Purchase Invoices",
                            Type: "Purchase",
                            Link: "ImpPurchaseInvoice",
                        },
                        {
                            Name: "Import Purchase Invoice Preview",
                            Type: "Purchase",
                            Link: "viewImpPurchaseInvoice",
                        },
                        {
                            Name: "Add Purchase Invoice",
                            Type: "Purchase",
                            Link: "addPurchaseInvoice",
                        },
                        {
                            Name: "Purchase Invoices",
                            Type: "Purchase",
                            Link: "PurchaseInvoice",
                        },
                        {
                            Name: "Purchase Invoice Preview",
                            Type: "Purchase",
                            Link: "viewPurchaseInvoice",
                        },
                        {
                            Name: "Add Purchase Return",
                            Type: "Purchase",
                            Link: "addPurchaseReturn",
                        },
                        {
                            Name: "Purchase Returns",
                            Type: "Purchase",
                            Link: "PurchaseReturn",
                        },
                        {
                            Name: "Purchase Return Preview",
                            Type: "Purchase",
                            Link: "viewPurchaseReturn",
                        },

                    ]
                },
                {
                    Category: "Sales",
                    Pages: [
                        {
                            Name: "Add Sales Enquiry",
                            Type: "Sales",
                            Link: "addSalesEnquiry",
                        },
                        {
                            Name: "Sales Enquiries",
                            Type: "Sales",
                            Link: "SalesEnquiry",
                        },
                        {
                            Name: "Sales Enquiry Preview",
                            Type: "Sales",
                            Link: "viewSalesEnquiry",
                        },
                        {
                            Name: "Add Sales Enquiry 2",
                            Type: "Sales",
                            Link: "addSalesEnquiry2",
                        },
                        {
                            Name: "Sales Enquiry 2",
                            Type: "Sales",
                            Link: "SalesEnquiry2",
                        },
                        {
                            Name: "Sales Enquiry 2 Preview",
                            Type: "Sales",
                            Link: "viewSalesEnquiry2",
                        },
                        {
                            Name: "Add Sales Enquiry 3",
                            Type: "Sales",
                            Link: "addSalesEnquiry3",
                        },
                        {
                            Name: "Sales Enquiry 3",
                            Type: "Sales",
                            Link: "SalesEnquiry3",
                        },
                        {
                            Name: "Sales Enquiry 3 Preview",
                            Type: "Sales",
                            Link: "viewSalesEnquiry3",
                        },
                        {
                            Name: "Add Sales Enquiry 4",
                            Type: "Sales",
                            Link: "addSalesEnquiry4",
                        },
                        {
                            Name: "Sales Enquiry 4",
                            Type: "Sales",
                            Link: "SalesEnquiry4",
                        },
                        {
                            Name: "Sales Enquiry 4 Preview",
                            Type: "Sales",
                            Link: "viewSalesEnquiry4",
                        },
                        {
                            Name: "Add Sales Quotation",
                            Type: "Sales",
                            Link: "addSalesQuotation",
                        },
                        {
                            Name: "Sales Quotations",
                            Type: "Sales",
                            Link: "SalesQuotation",
                        },
                        {
                            Name: "Sales Quotation Preview",
                            Type: "Sales",
                            Link: "viewSalesQuotation",
                        },
                        {
                            Name: "Add Sales Quotation 2",
                            Type: "Sales",
                            Link: "addSalesQuotation2",
                        },
                        {
                            Name: "Sales Quotation 2",
                            Type: "Sales",
                            Link: "SalesQuotation2",
                        },
                        {
                            Name: "Sales Quotation 2 Preview",
                            Type: "Sales",
                            Link: "viewSalesQuotation2",
                        },
                        {
                            Name: "Add Sales Quotation 3",
                            Type: "Sales",
                            Link: "addSalesQuotation3",
                        },
                        {
                            Name: "Sales Quotation 3",
                            Type: "Sales",
                            Link: "SalesQuotation3",
                        },
                        {
                            Name: "Sales Quotation 3 Preview",
                            Type: "Sales",
                            Link: "viewSalesQuotation3",
                        },
                        {
                            Name: "Add Sales Quotation 4",
                            Type: "Sales",
                            Link: "addSalesQuotation4",
                        },
                        {
                            Name: "Sales Quotation 4",
                            Type: "Sales",
                            Link: "SalesQuotation4",
                        },
                        {
                            Name: "Sales Quotation 4 Preview",
                            Type: "Sales",
                            Link: "viewSalesQuotation4",
                        },


                        {
                            Name: "Add Sales Order",
                            Type: "Sales",
                            Link: "addSalesOrder",
                        },
                        {
                            Name: "Sales Orders",
                            Type: "Sales",
                            Link: "SalesOrder",
                        },
                        {
                            Name: "Sales Order Preview",
                            Type: "Sales",
                            Link: "viewSalesOrder",
                        },

                        {
                            Name: "Add Sales Order 2",
                            Type: "Sales",
                            Link: "addSalesOrder2",
                        },
                        {
                            Name: "Sales Order 2",
                            Type: "Sales",
                            Link: "SalesOrder2",
                        },
                        {
                            Name: "Sales Order 2 Preview",
                            Type: "Sales",
                            Link: "viewSalesOrder2",
                        },

                        {
                            Name: "Add Sales Order 3",
                            Type: "Sales",
                            Link: "addSalesOrder3",
                        },
                        {
                            Name: "Sales Order 3",
                            Type: "Sales",
                            Link: "SalesOrder3",
                        },
                        {
                            Name: "Sales Order 3 Preview",
                            Type: "Sales",
                            Link: "viewSalesOrder3",
                        },

                        {
                            Name: "Add Sales Order 4",
                            Type: "Sales",
                            Link: "addSalesOrder4",
                        },
                        {
                            Name: "Sales Order 4",
                            Type: "Sales",
                            Link: "SalesOrder4",
                        },
                        {
                            Name: "Sales Order 4 Preview",
                            Type: "Sales",
                            Link: "viewSalesOrder4",
                        },

                        {
                            Name: "Add Packing List",
                            Type: "Sales",
                            Link: "addPackingList",
                        },
                        {
                            Name: "Packing Lists",
                            Type: "PackingList",
                            Link: "PackingList",
                        },
                        {
                            Name: "Packing List Preview",
                            Type: "Sales",
                            Link: "viewPackingList",
                        },
                        {
                            Name: "Add Delivery Note",
                            Type: "Sales",
                            Link: "addDeliveryNote",
                        },
                        {
                            Name: "Delivery Notes",
                            Type: "Sales",
                            Link: "DeliveryNote",
                        },
                        {
                            Name: "Delivery Note Preview",
                            Type: "Sales",
                            Link: "viewDeliveryNote",
                        },
                        {
                            Name: "Add Delivery Note 2",
                            Type: "Sales",
                            Link: "addDeliveryNote2",
                        },
                        {
                            Name: "Delivery Note 2",
                            Type: "Sales",
                            Link: "DeliveryNote2",
                        },
                        {
                            Name: "Delivery Note 2 Preview",
                            Type: "Sales",
                            Link: "viewDeliveryNote2",
                        },
                        {
                            Name: "Add Delivery Note 3",
                            Type: "Sales",
                            Link: "addDeliveryNote3",
                        },
                        {
                            Name: "Delivery Note 3",
                            Type: "Sales",
                            Link: "DeliveryNote3",
                        },
                        {
                            Name: "Delivery Note 3 Preview",
                            Type: "Sales",
                            Link: "viewDeliveryNote3",
                        },
                        {
                            Name: "Add Delivery Note 4",
                            Type: "Sales",
                            Link: "addDeliveryNote4",
                        },
                        {
                            Name: "Delivery Note 4",
                            Type: "Sales",
                            Link: "DeliveryNote4",
                        },
                        {
                            Name: "Delivery Note 4 Preview",
                            Type: "Sales",
                            Link: "viewDeliveryNote4",
                        },
                        {
                            Name: "Add Export Sales Invoice",
                            Type: "Sales",
                            Link: "addExpSalesInvoice",
                        },
                        {
                            Name: "Export Sales Invoices",
                            Type: "Sales",
                            Link: "ExpSalesInvoice",
                        },
                        {
                            Name: "Export Sales Invoice Preview",
                            Type: "Sales",
                            Link: "viewExpSalesInvoice",
                        },
                        {
                            Name: "Add Dierct Sales Invoice",
                            Type: "Sales",
                            Link: "addDirSalesInvoice",
                        },
                        {
                            Name: "Direct Sales Invoices",
                            Type: "Sales",
                            Link: "DirSalesInvoice",
                        },
                        {
                            Name: "Direct Sales Invoice Preview",
                            Type: "Sales",
                            Link: "viewDirSalesInvoice",
                        },
                        {
                            Name: "Add Individual Sales Invoice",
                            Type: "Sales",
                            Link: "addIndSalesInvoice",
                        },
                        {
                            Name: "Individual Sales Invoices",
                            Type: "Sales",
                            Link: "IndSalesInvoice",
                        },
                        {
                            Name: "Individual Sales Invoice Preview",
                            Type: "Sales",
                            Link: "viewIndSalesInvoice",
                        },
                        {
                            Name: "Add Porfoma Invoice",
                            Type: "Sales",
                            Link: "addPorSalesInvoice",
                        },
                        {
                            Name: "Porfoma Invoices",
                            Type: "Sales",
                            Link: "PorSalesInvoice",
                        },
                        {
                            Name: "Porfoma Invoice Preview",
                            Type: "Sales",
                            Link: "viewPorSalesInvoice",
                        },
                        {
                            Name: "Add Sales Invoice",
                            Type: "Sales",
                            Link: "addSalesInvoice",
                        },
                        {
                            Name: "Sales Invoices",
                            Type: "Sales",
                            Link: "SalesInvoice",
                        },
                        {
                            Name: "Sales Invoice Preview",
                            Type: "Sales",
                            Link: "viewSalesInvoice",
                        },
                        {
                            Name: "Add Sales Invoice 2",
                            Type: "Sales",
                            Link: "addSalesInvoice2",
                        },
                        {
                            Name: "Sales Invoice 2",
                            Type: "Sales",
                            Link: "SalesInvoice2",
                        },
                        {
                            Name: "Sales Invoice 2 Preview",
                            Type: "Sales",
                            Link: "viewSalesInvoice2",
                        },
                        {
                            Name: "Add Sales Invoice 3",
                            Type: "Sales",
                            Link: "addSalesInvoice3",
                        },
                        {
                            Name: "Sales Invoice 3",
                            Type: "Sales",
                            Link: "SalesInvoice3",
                        },
                        {
                            Name: "Sales Invoice 3 Preview",
                            Type: "Sales",
                            Link: "viewSalesInvoice3",
                        },
                        {
                            Name: "Add Sales Invoice 4",
                            Type: "Sales",
                            Link: "addSalesInvoice4",
                        },
                        {
                            Name: "Sales Invoice 4",
                            Type: "Sales",
                            Link: "SalesInvoice4",
                        },
                        {
                            Name: "Sales Invoice 4 Preview",
                            Type: "Sales",
                            Link: "viewSalesInvoice4",
                        },
                        {
                            Name: "Add Sales Return",
                            Type: "Sales",
                            Link: "addSalesReturn",
                        },
                        {
                            Name: "Sales Returns",
                            Type: "Sales",
                            Link: "SalesReturn",
                        },
                        {
                            Name: "Sales Return Preview",
                            Type: "Sales",
                            Link: "viewSalesReturn",
                        }, {
                            Name: "Add Credit Note SR",
                            Type: "Sales",
                            Link: "addCreditNoteSR",
                        },
                        {
                            Name: "Credit Note SR",
                            Type: "Sales",
                            Link: "CreditNoteSR",
                        },
                        {
                            Name: "Credit Note SR Preview",
                            Type: "Sales",
                            Link: "viewCreditNoteSR",
                        },

                    ]
                },
                {
                    Category: "Basic Vouchers",
                    Pages: [
                        {
                            Name: "Add Opening Balance",
                            Type: "Basic Vouchers",
                            Link: "addOpeningBalance",
                        },
                        {
                            Name: "Opening Balance",
                            Type: "Basic Vouchers",
                            Link: "OpeningBalance",
                        },
                        {
                            Name: "Opening Balance Preview",
                            Type: "Basic Vouchers",
                            Link: "viewOpeningBalance",
                        },
                        {
                            Name: "Add Journal Voucher",
                            Type: "Basic Vouchers",
                            Link: "addJVMaster",
                        },
                        {
                            Name: "Journal Voucher",
                            Type: "Basic Vouchers",
                            Link: "JVMaster",
                        },
                        {
                            Name: "Journal Voucher Preview",
                            Type: "Basic Vouchers",
                            Link: "viewJVMaster",
                        },
                        {
                            Name: "Add Credit Note",
                            Type: "Basic Vouchers",
                            Link: "addCreditNote",
                        },
                        {
                            Name: "Credit Note",
                            Type: "Basic Vouchers",
                            Link: "CreditNote",
                        },
                        {
                            Name: "Credit Note Preview",
                            Type: "Basic Vouchers",
                            Link: "viewCreditNote",
                        },
                        {
                            Name: "Add Debit Note",
                            Type: "Basic Vouchers",
                            Link: "addDebitNote",
                        },
                        {
                            Name: "Debit Note",
                            Type: "Basic Vouchers",
                            Link: "DebitNote",
                        },
                        {
                            Name: "Debit Note Preview",
                            Type: "Basic Vouchers",
                            Link: "viewDebitNote",
                        },
                        {
                            Name: "Add Company Expense",
                            Type: "Basic Vouchers",
                            Link: "addcompanyExpense",
                        },
                        {
                            Name: "Company Expense",
                            Type: "Basic Vouchers",
                            Link: "companyExpense",
                        },
                        {
                            Name: "Company Expense Preview",
                            Type: "Basic Vouchers",
                            Link: "viewcompanyExpense",
                        },
                    ]
                },
                {
                    Category: "Payment Vouchers",
                    Pages: [
                        {
                            Name: "Add Cash Payment",
                            Type: "Payment Vouchers",
                            Link: "addCPVMaster",
                        },
                        {
                            Name: "Cash Payments",
                            Type: "Payment Vouchers",
                            Link: "CPVMaster",
                        },
                        {
                            Name: "Cash Payment Preview",
                            Type: "Payment Vouchers",
                            Link: "viewCPVMaster",
                        },
                        {
                            Name: "Add Fund Payment",
                            Type: "Payment Vouchers",
                            Link: "addFPVMaster",
                        },
                        {
                            Name: "Fund Payments",
                            Type: "Payment Vouchers",
                            Link: "FPVMaster",
                        },
                        {
                            Name: "Fund Payment Preview",
                            Type: "Payment Vouchers",
                            Link: "viewFPVMaster",
                        },
                        {
                            Name: "Add Cheque Payment",
                            Type: "Payment Vouchers",
                            Link: "addChequePVMaster",
                        },
                        {
                            Name: "Cheque Payments",
                            Type: "Payment Vouchers",
                            Link: "ChequePVMaster",
                        },
                        {
                            Name: "Cheque Payment Preview",
                            Type: "Payment Vouchers",
                            Link: "viewChequePVMaster",
                        },
                    ]
                },
                {
                    Category: "Receipt Vouchers",
                    Pages: [
                        {
                            Name: "Add Cash Receipt",
                            Type: "Receipt Vouchers",
                            Link: "addCRVMaster",
                        },
                        {
                            Name: "Cash Receipts",
                            Type: "Receipt Vouchers",
                            Link: "CRVMaster",
                        },
                        {
                            Name: "Cash Receipt Preview",
                            Type: "Receipt Vouchers",
                            Link: "viewCRVMaster",
                        },
                        {
                            Name: "Add Fund Receipt",
                            Type: "Receipt Vouchers",
                            Link: "addFRVMaster",
                        },
                        {
                            Name: "Fund Receipts",
                            Type: "Receipt Vouchers",
                            Link: "FRVMaster",
                        },
                        {
                            Name: "Fund Receipt Preview",
                            Type: "Receipt Vouchers",
                            Link: "viewFRVMaster",
                        },
                        {
                            Name: "Add Cheque Receipt",
                            Type: "Receipt Vouchers",
                            Link: "addChequeRVMaster",
                        },
                        {
                            Name: "Cheque Receipts",
                            Type: "Receipt Vouchers",
                            Link: "ChequeRVMaster",
                        },
                        {
                            Name: "Cheque Receipt Preview",
                            Type: "Receipt Vouchers",
                            Link: "viewChequeRVMaster",
                        },
                    ]
                },
                {
                    Category: "CRM",
                    Pages: [
                        {
                            Name: "Add Lead",
                            Type: "CRM",
                            Link: "addLead",
                        },
                        {
                            Name: "Lead",
                            Type: "CRM",
                            Link: "lead",
                        },
                        {
                            Name: "Lead Source",
                            Type: "CRM",
                            Link: "leadSource",
                        },
                        {
                            Name: "Lead Type",
                            Type: "CRM",
                            Link: "leadType",
                        },
                        {
                            Name: "Opportunity",
                            Type: "CRM",
                            Link: "opportunity",
                        },

                    ]
                },
                {
                    Category: "Task",
                    Pages: [
                        {
                            Name: "Task Type",
                            Type: "Task",
                            Link: "taskType",
                        },
                        {
                            Name: "Project",
                            Type: "Task",
                            Link: "project",
                        },
                        {
                            Name: "Task",
                            Type: "Task",
                            Link: "task",
                        },
                    ]
                },
                {
                    Category: "POS",
                    Pages: [
                        {
                            Name: "Counters",
                            Type: "POS",
                            Link: "counter",
                        },
                        {
                            Name: "Counter Sales",
                            Type: "POS",
                            Link: "counterSales",
                        },
                        {
                            Name: "Counter Sales Edit",
                            Type: "POS",
                            Link: "counterSalesEdit",
                        },
                        {
                            Name: "Counter Sales Table",
                            Type: "POS",
                            Link: "counterSalesTable",
                        },
                        {
                            Name: "Counter Sales Touch",
                            Type: "POS",
                            Link: "counterSalesTouch",
                        },
                        {
                            Name: "Bill Review",
                            Type: "POS",
                            Link: "billReview",
                        },

                    ]
                },
                {
                    Category: "PDC",
                    Pages: [
                        {
                            Name: "Pending PDCs",
                            Type: "PDC",
                            Link: "PendingPDC",
                        },
                        {
                            Name: "Processed PDCs",
                            Type: "PDC",
                            Link: "ProcessedPDC",
                        },
                        {
                            Name: "Reconcile Cheque Payments",
                            Type: "PDC",
                            Link: "ReconcileChequePay",
                        },
                        {
                            Name: "Reconcile Cheque Receipts",
                            Type: "PDC",
                            Link: "ReconcileChequeRec",
                        }, {
                            Name: "Bounce Cheque Payments",
                            Type: "PDC",
                            Link: "BounceChequePay",
                        },
                        {
                            Name: "Bounce Cheque Receipts",
                            Type: "PDC",
                            Link: "BounceChequeRec",
                        },
                    ]
                },
                {
                    Category: "Stock",
                    Pages: [
                        {
                            Name: "Add Opening Stock",
                            Type: "Stock",
                            Link: "addOpeningStock",
                        },
                        {
                            Name: "Opening Stocks",
                            Type: "Stock",
                            Link: "OpeningStock",
                        },
                        {
                            Name: "Opening Stock Preview",
                            Type: "Stock",
                            Link: "viewOpeningStock",
                        },
                        {
                            Name: "Add Stock Issue",
                            Type: "Stock",
                            Link: "addStockIssue",
                        },
                        {
                            Name: "Stock Issues",
                            Type: "Stock",
                            Link: "StockIssue",
                        },
                        {
                            Name: "Stock Issue Preview",
                            Type: "Stock",
                            Link: "viewStockIssue",
                        },
                        {
                            Name: "Add Stock JV",
                            Type: "Stock",
                            Link: "addStockJV",
                        },
                        {
                            Name: "Stock JVs",
                            Type: "Stock",
                            Link: "StockJV",
                        },
                        {
                            Name: "Stock JV Preview",
                            Type: "Stock",
                            Link: "viewStockJV",
                        },
                        {
                            Name: "Add Stock FOC",
                            Type: "Stock",
                            Link: "addStockFOC",
                        },
                        {
                            Name: "Stock FOC",
                            Type: "Stock",
                            Link: "StockFOC",
                        },
                        {
                            Name: "Stock FOC Preview",
                            Type: "Stock",
                            Link: "viewStockFOC",
                        },
                        {
                            Name: "Add Stock Recieve",
                            Type: "Stock",
                            Link: "addStockRecieve",
                        },
                        {
                            Name: "Stock Recieves",
                            Type: "Stock",
                            Link: "StockRecieve",
                        },
                        {
                            Name: "Stock Receive Preview",
                            Type: "Stock",
                            Link: "viewStockRecieve",
                        },

                    ]
                },
                {
                    Category: "Approvals",
                    Pages: [
                        {
                            Name: "Cheque Receipt Approvals",
                            Type: "Approvals",
                            Link: "ApprovalChequeRVMaster",
                        },
                        {
                            Name: "Cheque Payment Approvals",
                            Type: "Approvals",
                            Link: "ApprovalChequePVMaster",
                        },
                        {
                            Name: "Opening Balance Approvals",
                            Type: "Approvals",
                            Link: "ApprovalOpeningBalance",
                        },
                        {
                            Name: "Company Expense Approvals",
                            Type: "Approvals",
                            Link: "ApprovalcompanyExpense",
                        },
                        {
                            Name: "Debit Note Approvals",
                            Type: "Approvals",
                            Link: "ApprovalDebitNote",
                        },
                        {
                            Name: "Credit Note Approvals",
                            Type: "Approvals",
                            Link: "ApprovalCreditNote",
                        },
                        {
                            Name: "Journal Voucher Approvals",
                            Type: "Approvals",
                            Link: "ApprovalJVMaster",
                        },
                        {
                            Name: "Fund Receipt Approvals",
                            Type: "Approvals",
                            Link: "ApprovalFRVMaster",
                        },
                        {
                            Name: "Fund Payment Approvals",
                            Type: "Approvals",
                            Link: "ApprovalFPVMaster",
                        },
                        {
                            Name: "Cash Receipt Approvals",
                            Type: "Approvals",
                            Link: "ApprovalCRVMaster",
                        },
                        {
                            Name: "Cash Payment Approvals",
                            Type: "Approvals",
                            Link: "ApprovalCPVMaster",
                        },
                        {
                            Name: "Stock Issue Approvals",
                            Type: "Approvals",
                            Link: "ApprovalStockIssue",
                        },
                        {
                            Name: "Stock JV Approvals",
                            Type: "Approvals",
                            Link: "ApprovalStockJV",
                        },
                        {
                            Name: "Stock FOC Approvals",
                            Type: "Approvals",
                            Link: "ApprovalStockFOC",
                        },
                        {
                            Name: "Opening Stocks Approval",
                            Type: "Approvals",
                            Link: "ApprovalOpeningStock",
                        },
                        {
                            Name: "Stock Recieve Approvals",
                            Type: "Approvals",
                            Link: "ApprovalStockRecieve",
                        },

                    ]
                },
                {
                    Category: "HR",
                    Pages: [
                        {
                            Name: "Grade",
                            Type: "HR",
                            Link: "Grade",
                        }, {
                            Name: "Holiday",
                            Type: "HR",
                            Link: "holiday",
                        }, {
                            Name: "Attachment Type",
                            Type: "HR",
                            Link: "AttachmentType",
                        },
                        {
                            Name: "Attachment Type",
                            Type: "HR",
                            Link: "AttachmentType",
                        }, {
                            Name: "Shift",
                            Type: "HR",
                            Link: "Shift",
                        }, {
                            Name: "Work Type",
                            Type: "HR",
                            Link: "workType",
                        }, {
                            Name: "Leave Allocation",
                            Type: "HR",
                            Link: "LeaveAllocation",
                        }, {
                            Name: "Employee Leave Ledger",
                            Type: "HR",
                            Link: "EmployeeLeaveLedger",
                        }, {
                            Name: "Employee Vacation Ledger",
                            Type: "HR",
                            Link: "employeeVacationLedger",
                        },
                        {
                            Name: "Apply Leave",
                            Type: "HR",
                            Link: "ApplyLeave",
                        }, {
                            Name: "Leave List",
                            Type: "HR",
                            Link: "leaveList",
                        }, {
                            Name: "Add Earnings & Deductions",
                            Type: "HR",
                            Link: "EarningDeduction",
                        },
                        {
                            Name: "Earnings & Deductions List",
                            Type: "HR",
                            Link: "EarningDeductionList",
                        },
                        {
                            Name: "Employee Attachment",
                            Type: "HR",
                            Link: "EmployeeAttachment",
                        }, {
                            Name: "Employee Appraisals",
                            Type: "HR",
                            Link: "EmployeeAppraisals",
                        }, {
                            Name: "Payroll Settings",
                            Type: "HR",
                            Link: "payrollSettings",
                        }, {
                            Name: "Payroll Settings Grade",
                            Type: "HR",
                            Link: "payrollSettingsGrade",
                        }, {
                            Name: "Vacation Settings",
                            Type: "HR",
                            Link: "vacationSettings",
                        }, {
                            Name: "Employee Attendance",
                            Type: "HR",
                            Link: "employeeAttendance",
                        },
                        {
                            Name: "Add Employee Salary",
                            Type: "HR",
                            Link: "addEmployeeSalary",
                        },
                        {
                            Name: "Bulk Employee Salary",
                            Type: "HR",
                            Link: "bulkEmployeeSalary",
                        },
                        {
                            Name: "Employee Salary",
                            Type: "HR",
                            Link: "employeeSalary",
                        },
                        {
                            Name: "Resignation Forms",
                            Type: "HR",
                            Link: "ResignationForm",
                        },

                        {
                            Name: "Vacation Request",
                            Type: "HR",
                            Link: "VacationRequest",
                        }, {
                            Name: "Vacation Join",
                            Type: "HR",
                            Link: "vacationJoin",
                        },
                        {
                            Name: "View Resignation Form",
                            Type: "HR",
                            Link: "viewResignationForm",
                        },
                        {
                            Name: "View Vacation Request",
                            Type: "HR",
                            Link: "viewVacationRequest",
                        },
                        {
                            Name: "View Warning Letters",
                            Type: "HR",
                            Link: "ViewWarningLetters",
                        },
                        {
                            Name: "Warning Letters",
                            Type: "HR",
                            Link: "WarningLetter",
                        },
                        {
                            Name: "Opening Loan",
                            Type: "HR",
                            Link: "openingLoan",
                        },
                        {
                            Name: "Opening Loan List",
                            Type: "HR",
                            Link: "openingLoanList",
                        },
                        {
                            Name: "Loan Type",
                            Type: "HR",
                            Link: "loanType",
                        },
                        {
                            Name: "Employee Loan",
                            Type: "HR",
                            Link: "employeeLoan",
                        },
                        {
                            Name: "Employee Loan List",
                            Type: "HR",
                            Link: "employeeLoanList",
                        },

                    ]
                },
                {
                    Category: "Reports",
                    Pages: [

                        {
                            Name: "Purchase Enquiry Report",
                            Type: "Reports",
                            Link: "purchaseEnquiryReport",
                        },

                        {
                            Name: "Purchase Request Report",
                            Type: "Reports",
                            Link: "purchaseRequestReport",
                        },
                        {
                            Name: "Material Request Report",
                            Type: "Reports",
                            Link: "materialRequestReport",
                        },
                        {
                            Name: "Purchase Order Report",
                            Type: "Reports",
                            Link: "purchaseOrderReport",
                        },
                        {
                            Name: "Purchase Quotation Report",
                            Type: "Reports",
                            Link: "purchaseQuotationReport",
                        },
                        {
                            Name: "Goods Received Report",
                            Type: "Reports",
                            Link: "GoodsReceivedReport",
                        },
                        {
                            Name: "Purchase Invoice Report",
                            Type: "Reports",
                            Link: "purchaseInvoiceReport",
                        },
                        {
                            Name: "Direct Purchase Invoice Report",
                            Type: "Reports",
                            Link: "dirPurchaseInvoiceReport",
                        },
                        {
                            Name: "Individual Purchase Invoice Report",
                            Type: "Reports",
                            Link: "IndPurchaseInvoiceReport",
                        },
                        {
                            Name: "Export Purchase Invoice Report",
                            Type: "Reports",
                            Link: "expPurchaseInvoiceReport",
                        },
                        {
                            Name: "Import Purchase Invoice Report",
                            Type: "Reports",
                            Link: "impPurchaseInvoiceReport",
                        }, {
                            Name: "Individual Purchase Invoice Report",
                            Type: "Reports",
                            Link: "indPurchaseInvoiceReport",
                        },
                        {
                            Name: "Purchase Return Report",
                            Type: "Reports",
                            Link: "PurchaseReturnReport",
                        },
                        {
                            Name: "Vendor Wise Purchase Report",
                            Type: "Reports",
                            Link: "vendorWisePurchaseReport",
                        },
                        {
                            Name: "Product Wise Purchase Report",
                            Type: "Reports",
                            Link: "productWisePurchaseReport",
                        },
                        {
                            Name: "Pending Purchase Enquiry Report",
                            Type: "Reports",
                            Link: "pendingPurchaseEnquiryReport",
                        },
                        {
                            Name: "Pending Material Request Report",
                            Type: "Reports",
                            Link: "pendingMaterialRequestReport",
                        },
                        {
                            Name: "Pending Purchase Request Report",
                            Type: "Reports",
                            Link: "pendingPurchaseRequestReport",
                        },
                        {
                            Name: "Pending Purchase Quotation Report",
                            Type: "Reports",
                            Link: "pendingPurchaseQuotationReport",
                        },
                        {
                            Name: "Pending Purchase Order Report",
                            Type: "Reports",
                            Link: "pendingPurchaseOrderReport",
                        },
                        {
                            Name: "Pending Goods Received Report",
                            Type: "Reports",
                            Link: "pendingGoodsReceivedReport",
                        },
                        {
                            Name: "Pending Direct Purchase Invoice Report",
                            Type: "Reports",
                            Link: "pendingDirPurchaseInvoiceReport",
                        },
                        {
                            Name: "Pending Individual Purchase Invoice Report",
                            Type: "Reports",
                            Link: "pendingIndPurchaseInvoiceReport",
                        },
                        {
                            Name: "Pending Exp Purchase Invoice Report",
                            Type: "Reports",
                            Link: "pendingExpPurchaseInvoiceReport",
                        },
                        {
                            Name: "Pending Import Purchase Invoice Report",
                            Type: "Reports",
                            Link: "pendingImpPurchaseInvoiceReport",
                        }, {
                            Name: "Pending Individual Purchase Invoice Report",
                            Type: "Reports",
                            Link: "pendingIndPurchaseInvoiceReport",
                        },
                        {
                            Name: "Pending Purchase Invoice Report",
                            Type: "Reports",
                            Link: "pendingPurchaseInvoiceReport",
                        },
                        {
                            Name: "Pending Purchase Return Report",
                            Type: "Reports",
                            Link: "pendingPurchaseReturnReport",
                        },
                        {
                            Name: "Sales Enquiry Report",
                            Type: "Reports",
                            Link: "salesEnquiryReport",
                        },
                        {
                            Name: "Sales Enquiry 2 Report",
                            Type: "Reports",
                            Link: "salesEnquiry2Report",
                        },
                        {
                            Name: "Sales Enquiry 3 Report",
                            Type: "Reports",
                            Link: "salesEnquiry3Report",
                        },
                        {
                            Name: "Sales Enquiry 4 Report",
                            Type: "Reports",
                            Link: "salesEnquiry4Report",
                        },
                        {
                            Name: "Sales Quotation Report",
                            Type: "Reports",
                            Link: "salesQuotationReport",
                        },
                        {
                            Name: "Sales Quotation 2 Report",
                            Type: "Reports",
                            Link: "salesQuotation2Report",
                        },
                        {
                            Name: "Sales Quotation 3 Report",
                            Type: "Reports",
                            Link: "salesQuotation3Report",
                        },
                        {
                            Name: "Sales Quotation 4 Report",
                            Type: "Reports",
                            Link: "salesQuotation4Report",
                        },
                        {
                            Name: "Sales Order Report",
                            Type: "Reports",
                            Link: "salesOrderReport",
                        },
                        {
                            Name: "Sales Order 2 Report",
                            Type: "Reports",
                            Link: "salesOrder2Report",
                        },
                        {
                            Name: "Sales Order 3 Report",
                            Type: "Reports",
                            Link: "salesOrder3Report",
                        },

                        {
                            Name: "Sales Order 4 Report",
                            Type: "Reports",
                            Link: "salesOrder4Report",
                        },

                        {
                            Name: "Packing List Report",
                            Type: "Reports",
                            Link: "packingListReport",
                        },
                        {
                            Name: "Delivery Note Report",
                            Type: "Reports",
                            Link: "deliveryNoteReport",
                        },
                        {
                            Name: "Delivery Note 2 Report",
                            Type: "Reports",
                            Link: "deliveryNote2Report",
                        },
                        {
                            Name: "Delivery Note 3 Report",
                            Type: "Reports",
                            Link: "deliveryNote3Report",
                        },
                        {
                            Name: "Delivery Note 4 Report",
                            Type: "Reports",
                            Link: "deliveryNote4Report",
                        },

                        {
                            Name: "Sales Invoice Report",
                            Type: "Reports",
                            Link: "salesInvoiceReport",
                        },
                        {
                            Name: "Sales Invoice 2 Report",
                            Type: "Reports",
                            Link: "salesInvoice2Report",
                        },
                        {
                            Name: "Sales Invoice 3 Report",
                            Type: "Reports",
                            Link: "salesInvoice3Report",
                        },
                        {
                            Name: "Sales Invoice 4 Report",
                            Type: "Reports",
                            Link: "salesInvoice4Report",
                        },

                        {
                            Name: "Porfoma Invoice Report",
                            Type: "Reports",
                            Link: "porfomaInvoiceReport",
                        },
                        {
                            Name: "Direct Sales Invoice Report",
                            Type: "Reports",
                            Link: "dirSalesInvoiceReport",
                        },
                        {
                            Name: "Individual Sales Invoice Report",
                            Type: "Reports",
                            Link: "IndSalesInvoiceReport",
                        },
                        {
                            Name: "Export Sales Invoice Report",
                            Type: "Reports",
                            Link: "expSalesInvoiceReport",
                        }, {
                            Name: "individual Sales Invoice Report",
                            Type: "Reports",
                            Link: "indSalesInvoiceReport",
                        },
                        {
                            Name: "Sales Return Report",
                            Type: "Reports",
                            Link: "salesReturnReport",
                        },
                        {
                            Name: "Customer Wise Sales Report",
                            Type: "Reports",
                            Link: "customerWiseSalesReport",
                        },
                        {
                            Name: "Product Wise Sales Report",
                            Type: "Reports",
                            Link: "productWiseSalesReport",
                        },
                        {
                            Name: "Product Wise Direct Sales Report",
                            Type: "Reports",
                            Link: "productWiseDirSalesReport",
                        },
                        {
                            Name: "Product Wise Individual Sales Report",
                            Type: "Reports",
                            Link: "productWiseIndSalesReport",
                        },
                        {
                            Name: "Product Wise Export Sales Report",
                            Type: "Reports",
                            Link: "productWiseExpSalesReport",
                        },
                        {
                            Name: "Product Wise Proforma Sales Report",
                            Type: "Reports",
                            Link: "productWiseProSalesReport",
                        },
                        {
                            Name: "Product Wise Direct Purchase Report",
                            Type: "Reports",
                            Link: "productWiseDirPurchaseReport",
                        },
                        {
                            Name: "Product Wise Import Purchase Report",
                            Type: "Reports",
                            Link: "productWiseImpPurchaseReport",
                        },
                        {
                            Name: "Product Wise Individual Purchase Report",
                            Type: "Reports",
                            Link: "productWiseIndPurchaseReport",
                        },
                        {
                            Name: "Purchase Queue",
                            Type: "Reports",
                            Link: "purchaseQueue",
                        },
                        {
                            Name: "Product Forcasiting",
                            Type: "Reports",
                            Link: "productForcasiting",
                        },
                        {
                            Name: "Product Query",
                            Type: "Reports",
                            Link: "productQuery",
                        },
                        {
                            Name: "Product Series",
                            Type: "Reports",
                            Link: "productSeries",
                        },

                        {
                            Name: "Customer Wise Direct Sales Report",
                            Type: "Reports",
                            Link: "customerWiseDirSalesReport",
                        },
                        {
                            Name: "Customer Wise Individual Sales Report",
                            Type: "Reports",
                            Link: "customerWiseIndSalesReport",
                        },
                        {
                            Name: "Customer Wise Export Sales Report",
                            Type: "Reports",
                            Link: "customerWiseExpSalesReport",
                        },
                        {
                            Name: "Customer Wise Proforma Sales Report",
                            Type: "Reports",
                            Link: "customerWiseProalesReport",
                        },
                        {
                            Name: "Vendor Wise Direct Purchase Report",
                            Type: "Reports",
                            Link: "VendorWiseDirPurchaseReport",
                        },
                        {
                            Name: "Vendor Wise Import Purchase Report",
                            Type: "Reports",
                            Link: "VendorWiseImpPurchaseReport",
                        },
                        {
                            Name: "Vendor Wise Individual Purchase Report",
                            Type: "Reports",
                            Link: "VendorWiseIndPurchaseReport",
                        },
                        {
                            Name: "Most Selling Items",
                            Type: "Reports",
                            Link: "mostSellingItems",
                        },
                        {
                            Name: "Less Selling Items",
                            Type: "Reports",
                            Link: "lessSellingItems",
                        },
                        {
                            Name: "Overdue Direct Sales Invoice",
                            Type: "Reports",
                            Link: "overdueDirSlsInvRpt",
                        },

                        {
                            Name: "Overdue Export Sales Invoice",
                            Type: "Reports",
                            Link: "overdueExpSlsInvReport",
                        },
                        {
                            Name: "Overdue Individual Sales Invoice",
                            Type: "Reports",
                            Link: "overdueIndSlsInvReport",
                        },
                        {
                            Name: "Overdue Sales Invoice",
                            Type: "Reports",
                            Link: "overdueSalesInvReport",
                        },
                        {
                            Name: "Pending Sales Enquiry Report",
                            Type: "Reports",
                            Link: "pendingSalesEnquiryReport",
                        },
                        {
                            Name: "Pending Sales Quotation Report",
                            Type: "Reports",
                            Link: "pendingSalesQuotationReport",
                        },
                        {
                            Name: "Pending Sales Order Report",
                            Type: "Reports",
                            Link: "pendingSalesOrderReport",
                        },
                        {
                            Name: "Pending PackingList Report",
                            Type: "Reports",
                            Link: "pendingPackingListReport",
                        },
                        {
                            Name: "Pending Delivery Note Report",
                            Type: "Reports",
                            Link: "pendingdeliveryNoteReport",
                        },
                        {
                            Name: "Pending Sales Invoice Report",
                            Type: "Reports",
                            Link: "pendingsalesInvoiceReport",
                        },
                        {
                            Name: "Pending Dir Sales Invoice Report",
                            Type: "Reports",
                            Link: "pendingdirSalesInvoiceReport",
                        },
                        {
                            Name: "Pending Exp Sales Invoice Report",
                            Type: "Reports",
                            Link: "pendingExpSalesInvoiceReport",
                        }, {
                            Name: "Pending Individual Sales Invoice Report",
                            Type: "Reports",
                            Link: "pendingIndSalesInvoiceReport",
                        },
                        {
                            Name: "Pending Porfoma Invoice Report",
                            Type: "Reports",
                            Link: "pendingPorfomaInvoiceReport",
                        },
                        {
                            Name: "Pending Sales Return Report",
                            Type: "Reports",
                            Link: "pendingSalesReturnReport",
                        },
                        {
                            Name: "All Payment Report",
                            Type: "Reports",
                            Link: "paymentReport",
                        }, {
                            Name: "All Receipt Report",
                            Type: "Reports",
                            Link: "receiptReport",
                        }, {
                            Name: "Cash Payment Report",
                            Type: "Reports",
                            Link: "cashPaymentReport",
                        },
                        {
                            Name: "Cash Receipt Report",
                            Type: "Reports",
                            Link: "chequeReceiptReport",
                        },
                        {
                            Name: "Fund Payment Report",
                            Type: "Reports",
                            Link: "fundPaymentReport",
                        },
                        {
                            Name: "Fund Receipt Report",
                            Type: "Reports",
                            Link: "fundReceiptReport",
                        },
                        {
                            Name: "Cheque Payment Report",
                            Type: "Reports",
                            Link: "chequePaymentReport",
                        },
                        {
                            Name: "Cheque Receipt Report",
                            Type: "Reports",
                            Link: "cashReceiptReport",
                        },
                        {
                            Name: "Journal Voucher Report",
                            Type: "Reports",
                            Link: "journalVoucherReport",
                        },
                        {
                            Name: "Credit Note Report",
                            Type: "Reports",
                            Link: "creditNoteReport",
                        },
                        {
                            Name: "Debit Note Report",
                            Type: "Reports",
                            Link: "debitNoteReport",
                        },
                        {
                            Name: "Opening Balance Report",
                            Type: "Reports",
                            Link: "openingBalanceReport",
                        },
                        {
                            Name: "Company Expense Report",
                            Type: "Reports",
                            Link: "companyExpenseReport",
                        },
                        {
                            Name: "Stock Ledger",
                            Type: "Reports",
                            Link: "stockLedger",
                        }, {
                            Name: "Stock Ledger Summary",
                            Type: "Reports",
                            Link: "stockLedgerSummary",
                        },
                        {
                            Name: "Stock Ledger Multi Unit",
                            Type: "Reports",
                            Link: "stockLedgerMU",
                        }, {
                            Name: "Warehouse Wise Ledger",
                            Type: "Reports",
                            Link: "warehouseLedger",
                        },
                        {
                            Name: "Stock List",
                            Type: "Reports",
                            Link: "stockList",
                        },
                        {
                            Name: "Warehouse Wise Stock List",
                            Type: "Reports",
                            Link: "warehouseStockList",
                        },
                        {
                            Name: "Warehouse Wise Stock Valuation",
                            Type: "Reports",
                            Link: "warehouseStockValuation",
                        },
                        {
                            Name: "Stock Movement",
                            Type: "Reports",
                            Link: "stockMovement",
                        },
                        {
                            Name: "Stock Valuation",
                            Type: "Reports",
                            Link: "stockValuation",
                        },
                        {
                            Name: "Product Detailed List",
                            Type: "Reports",
                            Link: "productDetailedList",
                        },
                        {
                            Name: "Batch Ledger",
                            Type: "Reports",
                            Link: "batchLedger",
                        },
                        {
                            Name: "Aging Analysis",
                            Type: "Reports",
                            Link: "AgingAnalysis",
                        },
                        {
                            Name: "Aging Analysis Summary",
                            Type: "Reports",
                            Link: "agingAnalysisSummary",
                        },
                        {
                            Name: "Aging Analysis Creditors",
                            Type: "Reports",
                            Link: "AgingAnalysisCreditors",
                        },
                        {
                            Name: "Aging Analysis Debtors",
                            Type: "Reports",
                            Link: "AgingAnalysisDebtors",
                        },
                        {
                            Name: "Bill Wise Aging",
                            Type: "Reports",
                            Link: "BillwiseAging",
                        },
                        {
                            Name: "Bill Wise Analysis",
                            Type: "Reports",
                            Link: "billwiseAnalysis",
                        },
                        {
                            Name: "List Of Outstanding",
                            Type: "Reports",
                            Link: "billwiseOutstanding",
                        },
                        {
                            Name: "List Of Outstanding Debit",
                            Type: "Reports",
                            Link: "listofoutstandingDebit",
                        },
                        {
                            Name: "List Of Outstanding Credit",
                            Type: "Reports",
                            Link: "listofoutstandingCredit",
                        },
                        {
                            Name: "Bill Wise Report",
                            Type: "Reports",
                            Link: "billwiseReport",
                        },
                        {
                            Name: "Bill Adjustment Report",
                            Type: "Reports",
                            Link: "billAdjustmentReport",
                        },
                        {
                            Name: "General Ledger",
                            Type: "Reports",
                            Link: "generalLedger",
                        }, {
                            Name: "General Ledger PDC",
                            Type: "Reports",
                            Link: "generalLedgerPDC",
                        }, {
                            Name: "Cost Ledger",
                            Type: "Reports",
                            Link: "costLedger",
                        },
                        {
                            Name: "Trail Balance",
                            Type: "Reports",
                            Link: "trailBalance",
                        },
                        {
                            Name: "Profit & Loss",
                            Type: "Reports",
                            Link: "profitLoss",
                        },
                        {
                            Name: "Balance Sheet",
                            Type: "Reports",
                            Link: "balanceSheet",
                        }, {
                            Name: "Vat Report",
                            Type: "Reports",
                            Link: "vatReport",
                        },
                        {
                            Name: "Conflicted Ledgers",
                            Type: "Reports",
                            Link: "conflictedLedgers",
                        },
                        {
                            Name: "Job Wise Profit",
                            Type: "Reports",
                            Link: "JobWiseProfit",
                        },
                        {
                            Name: "Job Wise Profit Details",
                            Type: "Reports",
                            Link: "JobWiseProfitDetails",
                        },
                        {
                            Name: "Project Wise Profit",
                            Type: "Reports",
                            Link: "ProjectWiseProfit",
                        }, {
                            Name: "Project Wise Profit Details",
                            Type: "Reports",
                            Link: "ProjectWiseProfitDetails",
                        }, {
                            Name: "POS Summary Report",
                            Type: "Reports",
                            Link: "POSSalesSummaryReport",
                        }, {
                            Name: "POS Detail Report",
                            Type: "Reports",
                            Link: "POSSalesDetailReport",
                        },
                        {
                            Name: "Employee Wise POS Report",
                            Type: "Reports",
                            Link: "employeeWisePosReport",
                        },
                        {
                            Name: "Warehouse Wise POS Report",
                            Type: "Reports",
                            Link: "warehouseWisePosReport",
                        },
                        {
                            Name: "Credit Note SR Report",
                            Type: "Reports",
                            Link: "creditNoteSRReport",
                        }, {
                            Name: "Attendance Report",
                            Type: "Reports",
                            Link: "attendanceReport",
                        }, {
                            Name: "Monthly Leave Report",
                            Type: "Reports",
                            Link: "leaveMonthlyReport",
                        }, {
                            Name: "Leave - Attendance Summary Report",
                            Type: "Reports",
                            Link: "leaveAttSumReport",
                        }, {
                            Name: "Leave Report",
                            Type: "Reports",
                            Link: "leaveReport",
                        },
                        {
                            Name: "Leave Report Summary",
                            Type: "Reports",
                            Link: "leaveReportSummary",
                        },
                        {
                            Name: "Paysheet Summary Report",
                            Type: "Reports",
                            Link: "paySheetSummaryReport",
                        },
                        {
                            Name: "Expired Employee Docs Report",
                            Type: "Reports",
                            Link: "expiredEmpDocsReport",
                        },
                        {
                            Name: "Reorder Report",
                            Type: "Reports",
                            Link: "reorderReport",
                        },
                        {
                            Name: "Stock Reserve Report",
                            Type: "Reports",
                            Link: "stockReserveReport",
                        },
                        {
                            Name: "Product Wise Aging",
                            Type: "Reports",
                            Link: "productWiseAging",
                        },
                        {
                            Name: "Opening Stock Report",
                            Type: "Reports",
                            Link: "openingStockReport",
                        },
                        {
                            Name: "Stock FOC Report",
                            Type: "Reports",
                            Link: "stockFOCReport",
                        },
                        {
                            Name: "Stock Issue Report",
                            Type: "Reports",
                            Link: "stockIssueReport",
                        },
                        {
                            Name: "Stock Receive Report",
                            Type: "Reports",
                            Link: "stockReceiveReport",
                        },
                        {
                            Name: "Stock JV Report",
                            Type: "Reports",
                            Link: "stockJVReport",
                        },
                        {
                            Name: "Link Report",
                            Type: "Reports",
                            Link: "LinkReport",
                        },

                    ]
                },
                {
                    Category: "Settings",
                    Pages: [
                        {
                            Name: "Profile",
                            Type: "Settings",
                            Link: "profile",
                        },
                        {
                            Name: "Favourite Links",
                            Type: "Settings",
                            Link: "Favourites",
                        },
                        {
                            Name: "Favourite Categories",
                            Type: "Settings",
                            Link: "Favourite Categories",
                        },
                        {
                            Name: "User Page Role",
                            Type: "Settings",
                            Link: "UserPageRole",
                        },
                        {
                            Name: "User Role Mapping",
                            Type: "Settings",
                            Link: "UserRoleMapping",
                        },
                        {
                            Name: "User Menu",
                            Type: "Settings",
                            Link: "userMenu",
                        },
                        {
                            Name: "Voucher Settings",
                            Type: "Settings",
                            Link: "VoucherSettings",
                        },
                        {
                            Name: "Cost Center Settings",
                            Type: "Settings",
                            Link: "VoucherCostCenter",
                        },
                        {
                            Name: "Voucher Accounts Loading",
                            Type: "Settings",
                            Link: "AccountLoading",
                        },
                        {
                            Name: "Voucher Design",
                            Type: "Settings",
                            Link: "VoucherDesign",
                        }, {
                            Name: "Table Design",
                            Type: "Settings",
                            Link: "TableDesign",
                        }, {
                            Name: "Tab Design",
                            Type: "Settings",
                            Link: "TabDesign",
                        },
                        {
                            Name: "Product Design",
                            Type: "Settings",
                            Link: "ProductDesign",
                        },
                        {
                            Name: "Custom Design",
                            Type: "Settings",
                            Link: "CustomDesign",
                        },
                        {
                            Name: "Cost Center Design",
                            Type: "Settings",
                            Link: "costCenterDesign",
                        },
                        {
                            Name: "Voucher Links",
                            Type: "Settings",
                            Link: "VoucherLinks",
                        },
                        {
                            Name: "Document Number",
                            Type: "Settings",
                            Link: "docNumber",
                        },
                        {
                            Name: "Extra Masters",
                            Type: "Settings",
                            Link: "ExtraMasters",
                        },
                        {
                            Name: "Voucher Names",
                            Type: "Settings",
                            Link: "VoucherNames",
                        },
                        {
                            Name: "Print Design",
                            Type: "Settings",
                            Link: "PrintDesign",
                        }, {
                            Name: "Print Settings",
                            Type: "Settings",
                            Link: "PrintSettings",
                        },
                        {
                            Name: "WhatsApp Settings",
                            Type: "Settings",
                            Link: "whatsAppSettings",
                        },
                        {
                            Name: "Resave Vouchers",
                            Type: "Settings",
                            Link: "resaveVouchers",
                        },
                        {
                            Name: "SMS Settings",
                            Type: "Settings",
                            Link: "SMSSettings",
                        }, {
                            Name: "Reminders",
                            Type: "Settings",
                            Link: "reminders",
                        }, {
                            Name: "Bill Edit",
                            Type: "Settings",
                            Link: "billEdit",
                        }, {
                        }, {
                            Name: "Inactive Accounts",
                            Type: "Settings",
                            Link: "inactiveAccounts",
                        }, {
                            Name: "Tickets",
                            Type: "Settings",
                            Link: "tickets",
                        }, {
                            Name: "Add Ticket",
                            Type: "Settings",
                            Link: "addticket",
                        }, {
                            Name: "Approval Config",
                            Type: "Settings",
                            Link: "approvalConfig",
                        },
                        {
                            Name: "Inactive Accounts",
                            Type: "Settings",
                            Link: "inactiveAccounts",
                        },
                        {
                            Name: "Missing Accounts",
                            Type: "Settings",
                            Link: "missingAccounts",
                        },
                        {
                            Name: "Bulk Print",
                            Type: "Settings",
                            Link: "bulkPrint",
                        },
                    ]
                },
                {
                    Category: "Property",
                    Pages: [

                        {
                            Name: "Building Type",
                            Type: "Property",
                            Link: "BuildingType",
                        }, {
                            Name: "Particulars",
                            Type: "Particulars",
                            Link: "Particulars",
                        },
                        {
                            Name: "Buildings",
                            Type: "Property",
                            Link: "Building",
                        },
                        {
                            Name: "Add Building",
                            Type: "Property",
                            Link: "AddBuilding",
                        },
                        {
                            Name: "Flat Type",
                            Type: "Property",
                            Link: "FlatType",
                        }, {
                            Name: "Flats",
                            Type: "Property",
                            Link: "Flat",
                        },
                        {
                            Name: "Add Flat",
                            Type: "Property",
                            Link: "AddFlat",
                        },
                        {
                            Name: "Flat Status",
                            Type: "Property",
                            Link: "FlatStatus",
                        },
                        {
                            Name: "Parking",
                            Type: "Property",
                            Link: "Parking",
                        },
                        {
                            Name: "Building Summary",
                            Type: "Property",
                            Link: "BuildingSummary",
                        },
                        {
                            Name: "Add Tenancy Contract",
                            Type: "Property",
                            Link: "AddTenancyContract",
                        },
                        {
                            Name: "Add Purchase Tenancy Contract",
                            Type: "Property",
                            Link: "AddPUTenancyContract",
                        },

                    ]
                },
                {
                    Category: "Documents",
                    Pages: [
                        {
                            Name: "Documents By Job",
                            Type: "Documents",
                            Link: "documentsByJobNo",
                        },
                        {
                            Name: "Voucher Documents",
                            Type: "Documents",
                            Link: "voucherDocs",
                        },
                    ]
                },
                {
                    Category: "Operations",
                    Pages: [
                        {
                            Name: "Add Time Sheet",
                            Type: "Operations",
                            Link: "addTimesheet",
                        },
                        {
                            Name: "Time Sheets",
                            Type: "Operations",
                            Link: "timeSheets",
                        },
                        {
                            Name: "Time Sheet Report",
                            Type: "Operations",
                            Link: "timesheetReport",
                        }, {
                            Name: "Work Order Pending Report",
                            Type: "Operations",
                            Link: "workOrderPendingReport",
                        }, {
                            Name: "Add Driver Payment Sheet",
                            Type: "Operations",
                            Link: "addDriverPaymentSheet",
                        },
                        {
                            Name: "Driver Payment Sheets",
                            Type: "Operations",
                            Link: "driverPaymentSheets",
                        }, {
                            Name: "Customer Driver Pay Config",
                            Type: "Operations",
                            Link: "customerDriverPayConfig",
                        },
                        {
                            Name: "Vehicle Allocation",
                            Type: "Operations",
                            Link: "vehicleAllocation",
                        },
                        {
                            Name: "Adspent Report",
                            Type: "Operations",
                            Link: "adspentReport",
                        },
                    ]
                }, {
                    Category: "Customizations",
                    Pages: [
                        {
                            Name: "Posting Templates",
                            Type: "Customizations",
                            Link: "postingTemplates",
                        }, 
                        {
                            Name: "Add Posting Templatess",
                            Type: "Customizations",
                            Link: "addPostingTemplates",
                        },
                        {
                            Name: "Reconcile Vouchers",
                            Type: "Customizations",
                            Link: "reconcileVouchers",
                        },
                    ]
                },




                //-----------UPLOADS----------


                //                {
                //                    Name: "Bulk Purchase Enquiry",
                //                    Type: "Uploads",
                //                    Link: "Basic",
                //                    },

                //----------PURCHASE-----------


                //----------SALES-----------



                //----------BASIC VOUCHERS-----------



                //----------PAYMENT VOUCHERS-----------



                //----------RECEIPT VOUCHERS-----------




                //----------CRM-----------


                //----------POS-----------


                //----------PDC-----------



                //----------STOCK-----------


                //----------HR-----------




                //----------REPORTS-----------

                //----------Other Reports----------- 

                //                {
                //                    Name: "Asset Balance",
                //                    Type: "Reports",
                //                    Link: "assetBalance",
                //                    },
                //                {
                //                    Name: "Asset Ledger",
                //                    Type: "Reports",
                //                    Link: "assetLedger",
                //                    },
                //                {
                //                    Name: "Cost Balance",
                //                    Type: "Reports",
                //                    Link: "costBalance",
                //                    },

                //                {
                //                    Name: "Counter Sales Report",
                //                    Type: "Reports",
                //                    Link: "counterSalesReport",
                //                    },
                //                {
                //                    Name: "Employee Sales Report",
                //                    Type: "Reports",
                //                    Link: "EmployeeSalesReport",
                //                    },
                //                {
                //                    Name: "Expenses Balance",
                //                    Type: "Reports",
                //                    Link: "expenseBalance",
                //                    },
                //                {
                //                    Name: "Expense Ledger",
                //                    Type: "Reports",
                //                    Link: "expenseLedger",
                //                    },
                //                {
                //                    Name: "Liabilities Balance",
                //                    Type: "Reports",
                //                    Link: "liabilitiesBalance",
                //                    },
                //                {
                //                    Name: "Liabilities Ledger",
                //                    Type: "Reports",
                //                    Link: "liabilitiesLedger",
                //                    },
                //                {
                //                    Name: "Other Revenue Balance",
                //                    Type: "Reports",
                //                    Link: "otherRevenewBalance",
                //                    },
                //                {
                //                    Name: "Other Revenew Ledger",
                //                    Type: "Reports",
                //                    Link: "otherRevenewLedgerController",
                //                    },
                //                {
                //                    Name: "Revenue Balance",
                //                    Type: "Reports",
                //                    Link: "revenewBalance",
                //                    },
                //                {
                //                    Name: "Revenew Ledger",
                //                    Type: "Reports",
                //                    Link: "revenewLedger",
                //                    },


                //----------Settings-----------



                //----------Property-----------

                //----------Documents-----------



            ];

            $scope.PagesSearch = [];
            angular.forEach($scope.PageList, function (e) {
                angular.forEach(e.Pages, function (a) {
                    $scope.PagesSearch.push(a);
                })
            })

            $scope.checkUserPageAccess = function (pageName) {

                $scope.PageAccessInfo = {};

                $scope.TokenInfo = AuthenticationService.getTokenInfo();

                if ($scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    var data = {
                        PageName: pageName,
                        UserId: $scope.TokenInfo.UserId,
                    }
                    MainService.CheckUserPageAccess(data).then(function (response) {
                        if (response.data != null && response.data != "") {
                            $scope.PageAccessInfo = response.data;
                        } else {
                            $state.go("forbidden");
                        }
                    }, function (err) {
                        toastr.error($scope.NetworkErrorLan);
                    });
                } else {
                    $scope.PageAccessInfo = {
                        PageName: pageName,
                        IsAccess: true,
                        IsAdd: true,
                        IsEdit: true,
                        IsRemove: true,
                        IsPrint: true,
                        IsView: true,
                    };
                }
            }

            $scope.OpenCustomMessageModal = function (msg) {
                $scope.CustomMessage = msg;
                $('#customMessageModal').modal('show');
            }

            $scope.VoucherPreLoad = {
                IsLoadPendingPreLoad: false,
                IsVoucherPreLoad: false,
            }
            $scope.setVoucherPreLoads = function (val) {
                $scope.VoucherPreLoad = {
                    IsLoadPendingPreLoad: val,
                    IsVoucherPreLoad: true,
                }
            }
            $scope.resetVoucherPreLoads = function (val) {
                $scope.VoucherPreLoad = {
                    IsLoadPendingPreLoad: false,
                    IsVoucherPreLoad: false,
                }
            }





            $scope.UpdateVoucherNames = function () {

                var temp1 = {
                    Id: 1,
                    Name: "Material Request",
                    NameVal: "Material Request",
                    Type: "MATERIAL_REQUEST"
                };
                if ($scope.CompanyProfile.MaterialRequest != "" & $scope.CompanyProfile.MaterialRequest != null) {
                    temp1.Name = $scope.CompanyProfile.MaterialRequest;
                }
                $scope.VoucherArray.push(temp1);

                var temp2 = {
                    Id: 2,
                    Name: "Purchase Request",
                    NameVal: "Purchase Request",
                    Type: "PURCHASE_REQUEST"
                };
                if ($scope.CompanyProfile.PurchaseRequest != "" & $scope.CompanyProfile.PurchaseRequest != null) {
                    temp2.Name = $scope.CompanyProfile.PurchaseRequest;
                }
                $scope.VoucherArray.push(temp2);

                var temp3 = {
                    Id: 3,
                    Name: "Purchase Enquiry",
                    NameVal: "Purchase Enquiry",
                    Type: "PURCHASE_ENQUIRY"
                };
                if ($scope.CompanyProfile.PurchaseEnquiry != "" & $scope.CompanyProfile.PurchaseEnquiry != null) {
                    temp3.Name = $scope.CompanyProfile.PurchaseEnquiry;
                }
                $scope.VoucherArray.push(temp3);

                var temp4 = {
                    Id: 4,
                    Name: "Purchase Quotation",
                    NameVal: "Purchase Quotation",
                    Type: "PURCHASE_QUOTATION"
                };
                if ($scope.CompanyProfile.PurchaseQuotation != "" & $scope.CompanyProfile.PurchaseQuotation != null) {
                    temp4.Name = $scope.CompanyProfile.PurchaseQuotation;
                }
                $scope.VoucherArray.push(temp4);

                var temp5 = {
                    Id: 5,
                    Name: "Purchase Order",
                    NameVal: "Purchase Order",
                    Type: "PURCHASE_ORDER"
                };
                if ($scope.CompanyProfile.PurchaseOrder != "" & $scope.CompanyProfile.PurchaseOrder != null) {
                    temp5.Name = $scope.CompanyProfile.PurchaseOrder;
                }
                $scope.VoucherArray.push(temp5);

                var temp6 = {
                    Id: 6,
                    Name: "Goods Received",
                    NameVal: "Goods Received",
                    Type: "GOODS_RECEIVED"
                };
                if ($scope.CompanyProfile.GoodsReceived != "" & $scope.CompanyProfile.GoodsReceived != null) {
                    temp6.Name = $scope.CompanyProfile.GoodsReceived;
                }
                $scope.VoucherArray.push(temp6);

                var temp7 = {
                    Id: 7,
                    Name: "Purchase Invoice",
                    NameVal: "Purchase Invoice",
                    Type: "PURCHASE_INVOICE"
                };
                if ($scope.CompanyProfile.PurchaseInvoice != "" & $scope.CompanyProfile.PurchaseInvoice != null) {
                    temp7.Name = $scope.CompanyProfile.PurchaseInvoice;
                }
                $scope.VoucherArray.push(temp7);

                var temp8 = {
                    Id: 8,
                    Name: "Direct Purchase Invoice",
                    NameVal: "Direct Purchase Invoice",
                    Type: "DIRECT_PURCHASE_INVOICE"
                };
                if ($scope.CompanyProfile.DirPurchaseInvoice != "" & $scope.CompanyProfile.DirPurchaseInvoice != null) {
                    temp8.Name = $scope.CompanyProfile.DirPurchaseInvoice;
                }
                $scope.VoucherArray.push(temp8);

                var temp9 = {
                    Id: 9,
                    Name: "Individual Purchase Invoice",
                    NameVal: "Individual Purchase Invoice",
                    Type: "INDIVIDUAL_PURCHASE_INVOICE"
                };
                if ($scope.CompanyProfile.IndPurchaseInvoice != "" & $scope.CompanyProfile.IndPurchaseInvoice != null) {
                    temp9.Name = $scope.CompanyProfile.IndPurchaseInvoice;
                }
                $scope.VoucherArray.push(temp9);

                var temp10 = {
                    Id: 10,
                    Name: "Import Purchase Invoice",
                    NameVal: "Import Purchase Invoice",
                    Type: "IMPORT_PURCHASE_INVOICE"
                };
                if ($scope.CompanyProfile.ImpPurchaseInvoice != "" & $scope.CompanyProfile.ImpPurchaseInvoice != null) {
                    temp10.Name = $scope.CompanyProfile.ImpPurchaseInvoice;
                }
                $scope.VoucherArray.push(temp10);

                var temp11 = {
                    Id: 11,
                    Name: "Export Purchase Invoice",
                    NameVal: "Export Purchase Invoice",
                    Type: "EXPORT_PURCHASE_INVOICE"
                };
                if ($scope.CompanyProfile.ExpPurchaseInvoice != "" & $scope.CompanyProfile.ExpPurchaseInvoice != null) {
                    temp11.Name = $scope.CompanyProfile.ExpPurchaseInvoice;
                }
                $scope.VoucherArray.push(temp11);

                var temp12 = {
                    Id: 12,
                    Name: "Purchase Return",
                    NameVal: "Purchase Return",
                    Type: "PURCHASE_RETURN"
                };
                if ($scope.CompanyProfile.PurchaseReturn != "" & $scope.CompanyProfile.PurchaseReturn != null) {
                    temp12.Name = $scope.CompanyProfile.PurchaseReturn;
                }
                $scope.VoucherArray.push(temp12);

                var temp13 = {
                    Id: 13,
                    Name: "Sales Enquiry",
                    NameVal: "Sales Enquiry",
                    Type: "SALES_ENQUIRY"
                };
                if ($scope.CompanyProfile.SalesEnquiry != "" & $scope.CompanyProfile.SalesEnquiry != null) {
                    temp13.Name = $scope.CompanyProfile.SalesEnquiry;
                }
                $scope.VoucherArray.push(temp13);

                var temp14 = {
                    Id: 14,
                    Name: "Sales Enquiry 2",
                    NameVal: "Sales Enquiry 2",
                    Type: "SALES_ENQUIRY_2"
                };
                if ($scope.CompanyProfile.SalesEnquiry2 != "" & $scope.CompanyProfile.SalesEnquiry2 != null) {
                    temp14.Name = $scope.CompanyProfile.SalesEnquiry2;
                }
                $scope.VoucherArray.push(temp14);

                var temp15 = {
                    Id: 15,
                    Name: "Sales Enquiry 3",
                    NameVal: "Sales Enquiry 3",
                    Type: "SALES_ENQUIRY_3"
                };
                if ($scope.CompanyProfile.SalesEnquiry3 != "" & $scope.CompanyProfile.SalesEnquiry3 != null) {
                    temp15.Name = $scope.CompanyProfile.SalesEnquiry3;
                }
                $scope.VoucherArray.push(temp15);

                var temp16 = {
                    Id: 16,
                    Name: "Sales Enquiry 4",
                    NameVal: "Sales Enquiry 4",
                    Type: "SALES_ENQUIRY_4"
                };
                if ($scope.CompanyProfile.SalesEnquiry4 != "" & $scope.CompanyProfile.SalesEnquiry4 != null) {
                    temp16.Name = $scope.CompanyProfile.SalesEnquiry4;
                }
                $scope.VoucherArray.push(temp16);

                var temp17 = {
                    Id: 17,
                    Name: "Sales Quotation",
                    NameVal: "Sales Quotation",
                    Type: "SALES_QUOTATION"
                };
                if ($scope.CompanyProfile.SalesQuotation != "" & $scope.CompanyProfile.SalesQuotation != null) {
                    temp17.Name = $scope.CompanyProfile.SalesQuotation;
                }
                $scope.VoucherArray.push(temp17);

                var temp18 = {
                    Id: 18,
                    Name: "Sales Quotation 2",
                    NameVal: "Sales Quotation 2",
                    Type: "SALES_QUOTATION_2"
                };
                if ($scope.CompanyProfile.SalesQuotation2 != "" & $scope.CompanyProfile.SalesQuotation2 != null) {
                    temp18.Name = $scope.CompanyProfile.SalesQuotation2;
                }
                $scope.VoucherArray.push(temp18);

                var temp19 = {
                    Id: 19,
                    Name: "Sales Quotation 3",
                    NameVal: "Sales Quotation 3",
                    Type: "SALES_QUOTATION_3"
                };
                if ($scope.CompanyProfile.SalesQuotation3 != "" & $scope.CompanyProfile.SalesQuotation3 != null) {
                    temp19.Name = $scope.CompanyProfile.SalesQuotation3;
                }
                $scope.VoucherArray.push(temp19);

                var temp20 = {
                    Id: 20,
                    Name: "Sales Quotation 4",
                    NameVal: "Sales Quotation 4",
                    Type: "SALES_QUOTATION_4"
                };
                if ($scope.CompanyProfile.SalesQuotation4 != "" & $scope.CompanyProfile.SalesQuotation4 != null) {
                    temp20.Name = $scope.CompanyProfile.SalesQuotation4;
                }
                $scope.VoucherArray.push(temp20);

                var temp21 = {
                    Id: 21,
                    Name: "Sales Order",
                    NameVal: "Sales Order",
                    Type: "SALES_ORDER"
                };
                if ($scope.CompanyProfile.SalesOrder != "" & $scope.CompanyProfile.SalesOrder != null) {
                    temp21.Name = $scope.CompanyProfile.SalesOrder;
                }
                $scope.VoucherArray.push(temp21);

                var temp22 = {
                    Id: 22,
                    Name: "Sales Order 2",
                    NameVal: "Sales Order 2",
                    Type: "SALES_ORDER_2"
                };
                if ($scope.CompanyProfile.SalesOrder2 != "" & $scope.CompanyProfile.SalesOrder2 != null) {
                    temp22.Name = $scope.CompanyProfile.SalesOrder2;
                }
                $scope.VoucherArray.push(temp22);

                var temp23 = {
                    Id: 23,
                    Name: "Sales Order 3",
                    NameVal: "Sales Order 3",
                    Type: "SALES_ORDER_3"
                };
                if ($scope.CompanyProfile.SalesOrder3 != "" & $scope.CompanyProfile.SalesOrder3 != null) {
                    temp23.Name = $scope.CompanyProfile.SalesOrder3;
                }
                $scope.VoucherArray.push(temp23);

                var temp24 = {
                    Id: 24,
                    Name: "Sales Order 4",
                    NameVal: "Sales Order 4",
                    Type: "SALES_ORDER_4"
                };
                if ($scope.CompanyProfile.SalesOrder4 != "" & $scope.CompanyProfile.SalesOrder4 != null) {
                    temp24.Name = $scope.CompanyProfile.SalesOrder4;
                }
                $scope.VoucherArray.push(temp24);

                var temp25 = {
                    Id: 25,
                    Name: "Delivery Note",
                    NameVal: "Delivery Note",
                    Type: "DELIVERY_NOTE"
                };
                if ($scope.CompanyProfile.DeliveryNote != "" & $scope.CompanyProfile.DeliveryNote != null) {
                    temp25.Name = $scope.CompanyProfile.DeliveryNote;
                }
                $scope.VoucherArray.push(temp25);

                var temp26 = {
                    Id: 26,
                    Name: "Delivery Note 2",
                    NameVal: "Delivery Note 2",
                    Type: "DELIVERY_NOTE_2"
                };
                if ($scope.CompanyProfile.DeliveryNote2 != "" & $scope.CompanyProfile.DeliveryNote2 != null) {
                    temp26.Name = $scope.CompanyProfile.DeliveryNote2;
                }
                $scope.VoucherArray.push(temp26);

                var temp27 = {

                    Id: 27,
                    Name: "Delivery Note 3",
                    NameVal: "Delivery Note 3",
                    Type: "DELIVERY_NOTE_3"
                };
                if ($scope.CompanyProfile.DeliveryNote3 != "" & $scope.CompanyProfile.DeliveryNote3 != null) {
                    temp27.Name = $scope.CompanyProfile.DeliveryNote3;
                }
                $scope.VoucherArray.push(temp27);

                var temp28 = {
                    Id: 28,
                    Name: "Delivery Note 4",
                    NameVal: "Delivery Note 4",
                    Type: "DELIVERY_NOTE_4"
                };
                if ($scope.CompanyProfile.DeliveryNote4 != "" & $scope.CompanyProfile.DeliveryNote4 != null) {
                    temp28.Name = $scope.CompanyProfile.DeliveryNote4;
                }
                $scope.VoucherArray.push(temp28);

                var temp29 = {
                    Id: 29,
                    Name: "Packing List",
                    NameVal: "Packing List",
                    Type: "PACKING_LIST"
                };
                if ($scope.CompanyProfile.PackingList != "" & $scope.CompanyProfile.PackingList != null) {
                    temp29.Name = $scope.CompanyProfile.PackingList;
                }
                $scope.VoucherArray.push(temp29);

                var temp30 = {
                    Id: 30,
                    Name: "Sales Invoice",
                    NameVal: "Sales Invoice",
                    Type: "SALES_INVOICE"
                };
                if ($scope.CompanyProfile.SalesInvoice != "" & $scope.CompanyProfile.SalesInvoice != null) {
                    temp30.Name = $scope.CompanyProfile.SalesInvoice;
                }
                $scope.VoucherArray.push(temp30);

                var temp31 = {
                    Id: 31,
                    Name: "Sales Invoice 2",
                    NameVal: "Sales Invoice 2",
                    Type: "SALES_INVOICE_2"
                };
                if ($scope.CompanyProfile.SalesInvoice2 != "" & $scope.CompanyProfile.SalesInvoice2 != null) {
                    temp31.Name = $scope.CompanyProfile.SalesInvoice2;
                }
                $scope.VoucherArray.push(temp31);

                var temp32 = {
                    Id: 32,
                    Name: "Sales Invoice 3",
                    NameVal: "Sales Invoice 3",
                    Type: "SALES_INVOICE_3"
                };
                if ($scope.CompanyProfile.SalesInvoice3 != "" & $scope.CompanyProfile.SalesInvoice3 != null) {
                    temp32.Name = $scope.CompanyProfile.SalesInvoice3;
                }
                $scope.VoucherArray.push(temp32);

                var temp33 = {
                    Id: 33,
                    Name: "Sales Invoice 4",
                    NameVal: "Sales Invoice 4",
                    Type: "SALES_INVOICE_4"
                };
                if ($scope.CompanyProfile.SalesInvoice4 != "" & $scope.CompanyProfile.SalesInvoice4 != null) {
                    temp33.Name = $scope.CompanyProfile.SalesInvoice4;
                }
                $scope.VoucherArray.push(temp33);

                var temp34 = {
                    Id: 34,
                    Name: "Direct Sales Invoice",
                    NameVal: "Direct Sales Invoice",
                    Type: "DIRECT_SALES_INVOICE"
                };
                if ($scope.CompanyProfile.DirSalesInvoice != "" & $scope.CompanyProfile.DirSalesInvoice != null) {
                    temp34.Name = $scope.CompanyProfile.DirSalesInvoice;
                }
                $scope.VoucherArray.push(temp34);

                var temp35 = {
                    Id: 35,
                    Name: "Individual Sales Invoice",
                    NameVal: "Individual Sales Invoice",
                    Type: "INDIVIDUAL_SALES_INVOICE"
                };
                if ($scope.CompanyProfile.IndSalesInvoice != "" & $scope.CompanyProfile.IndSalesInvoice != null) {
                    temp35.Name = $scope.CompanyProfile.IndSalesInvoice;
                }
                $scope.VoucherArray.push(temp35);

                var temp36 = {
                    Id: 36,
                    Name: "Export Sales Invoice",
                    NameVal: "Export Sales Invoice",
                    Type: "EXPORT_SALES_INVOICE"
                };
                if ($scope.CompanyProfile.ExpSalesInvoice != "" & $scope.CompanyProfile.ExpSalesInvoice != null) {
                    temp36.Name = $scope.CompanyProfile.ExpSalesInvoice;
                }
                $scope.VoucherArray.push(temp36);

                var temp37 = {
                    Id: 37,
                    Name: "Proforma Invoice",
                    NameVal: "Proforma Invoice",
                    Type: "PROFORMA_INVOICE"
                };
                if ($scope.CompanyProfile.ProformaInvoice != "" & $scope.CompanyProfile.ProformaInvoice != null) {
                    temp37.Name = $scope.CompanyProfile.ProformaInvoice;
                }
                $scope.VoucherArray.push(temp37);

                var temp38 = {
                    Id: 38,
                    Name: "Sales Return",
                    NameVal: "Sales Return",
                    Type: "SALES_RETURN"
                };
                if ($scope.CompanyProfile.SalesReturn != "" & $scope.CompanyProfile.SalesReturn != null) {
                    temp38.Name = $scope.CompanyProfile.SalesReturn;
                }
                $scope.VoucherArray.push(temp38);

                var temp39 = {
                    Id: 39,
                    Name: "Credit Note SR",
                    NameVal: "Credit Note SR",
                    Type: "CREDIT_NOTE_SR"
                };
                if ($scope.CompanyProfile.CreditNoteSR != "" & $scope.CompanyProfile.CreditNoteSR != null) {
                    temp39.Name = $scope.CompanyProfile.CreditNoteSR;
                }
                $scope.VoucherArray.push(temp39);

                var temp40 = {
                    Id: 40,
                    Name: "POS Sales",
                    NameVal: "POS",
                    Type: "POS"
                };
                if ($scope.CompanyProfile.POSSales != "" & $scope.CompanyProfile.POSSales != null) {
                    temp40.Name = $scope.CompanyProfile.POSSales;
                }
                $scope.VoucherArray.push(temp40);

                var temp41 = {
                    Id: 41,
                    Name: "Company Expense",
                    NameVal: "Company Expense",
                    Type: "COMPANY_EXPENSE"
                };
                if ($scope.CompanyProfile.CompanyExpense != "" & $scope.CompanyProfile.CompanyExpense != null) {
                    temp41.Name = $scope.CompanyProfile.CompanyExpense;
                }
                $scope.VoucherArray.push(temp41);

                var temp42 = {
                    Id: 42,
                    Name: "Journal Voucher",
                    NameVal: "Journal Voucher",
                    Type: "JOURNAL_VOUCHER"
                };
                if ($scope.CompanyProfile.JournalVoucher != "" & $scope.CompanyProfile.JournalVoucher != null) {
                    temp42.Name = $scope.CompanyProfile.JournalVoucher;
                }
                $scope.VoucherArray.push(temp42);

                var temp43 = {
                    Id: 43,
                    Name: "Opening Balance",
                    NameVal: "Opening Balance",
                    Type: "OPENING_BALANCE"
                };
                if ($scope.CompanyProfile.OpeningBalance != "" & $scope.CompanyProfile.OpeningBalance != null) {
                    temp43.Name = $scope.CompanyProfile.OpeningBalance;
                }
                $scope.VoucherArray.push(temp43);

                var temp44 = {
                    Id: 44,
                    Name: "Cash Payment",
                    NameVal: "Cash Payment",
                    Type: "CASH_PAYMENT"
                };
                if ($scope.CompanyProfile.CashPayment != "" & $scope.CompanyProfile.CashPayment != null) {
                    temp44.Name = $scope.CompanyProfile.CashPayment;
                }
                $scope.VoucherArray.push(temp44);

                var temp45 = {
                    Id: 45,
                    Name: "Cash Receipt",
                    NameVal: "Cash Receipt",
                    Type: "CASH_RECEIPT"
                };
                if ($scope.CompanyProfile.CashReceipt != "" & $scope.CompanyProfile.CashReceipt != null) {
                    temp45.Name = $scope.CompanyProfile.CashReceipt;
                }
                $scope.VoucherArray.push(temp45);

                var temp46 = {
                    Id: 46,
                    Name: "Fund Payment",
                    NameVal: "Fund Payment",
                    Type: "FUND_PAYMENT"
                };
                if ($scope.CompanyProfile.FundPayment != "" & $scope.CompanyProfile.FundPayment != null) {
                    temp46.Name = $scope.CompanyProfile.FundPayment;
                }
                $scope.VoucherArray.push(temp46);

                var temp47 = {
                    Id: 47,
                    Name: "Fund Receipt",
                    NameVal: "Fund Receipt",
                    Type: "FUND_RECEIPT"
                };
                if ($scope.CompanyProfile.FundReceipt != "" & $scope.CompanyProfile.FundReceipt != null) {
                    temp47.Name = $scope.CompanyProfile.FundReceipt;
                }
                $scope.VoucherArray.push(temp47);

                var temp48 = {
                    Id: 48,
                    Name: "Cheque Payment",
                    NameVal: "Cheque Payment",
                    Type: "CHEQUE_PAYMENT"
                };
                if ($scope.CompanyProfile.ChequePayment != "" & $scope.CompanyProfile.ChequePayment != null) {
                    temp48.Name = $scope.CompanyProfile.ChequePayment;
                }
                $scope.VoucherArray.push(temp48);

                var temp49 = {
                    Id: 49,
                    Name: "Cheque Receipt",
                    NameVal: "Cheque Receipt",
                    Type: "CHEQUE_RECEIPT"
                };
                if ($scope.CompanyProfile.ChequeReceipt != "" & $scope.CompanyProfile.ChequeReceipt != null) {
                    temp49.Name = $scope.CompanyProfile.ChequeReceipt;
                }
                $scope.VoucherArray.push(temp49);

                var temp50 = {
                    Id: 50,
                    Name: "Opening Stock",
                    NameVal: "Opening Stock",
                    Type: "OPENING_STOCK"
                };
                if ($scope.CompanyProfile.OpeningStock != "" & $scope.CompanyProfile.OpeningStock != null) {
                    temp50.Name = $scope.CompanyProfile.OpeningStock;
                }
                $scope.VoucherArray.push(temp50);

                var temp51 = {
                    Id: 51,
                    Name: "Stock Receive",
                    NameVal: "Stock Receive",
                    Type: "STOCK_RECEIVE"
                };
                if ($scope.CompanyProfile.StockReceive != "" & $scope.CompanyProfile.StockReceive != null) {
                    temp51.Name = $scope.CompanyProfile.StockReceive;
                }
                $scope.VoucherArray.push(temp51);

                var temp52 = {
                    Id: 52,
                    Name: "Stock Issue",
                    NameVal: "Stock Issue",
                    Type: "STOCK_ISSUE"
                };
                if ($scope.CompanyProfile.StockIssue != "" & $scope.CompanyProfile.StockIssue != null) {
                    temp52.Name = $scope.CompanyProfile.StockIssue;
                }
                $scope.VoucherArray.push(temp52);

                var temp53 = {
                    Id: 53,
                    Name: "Stock FOC",
                    NameVal: "Stock FOC",
                    Type: "STOCK_FOC"
                };
                if ($scope.CompanyProfile.StockFOC != "" & $scope.CompanyProfile.StockFOC != null) {
                    temp53.Name = $scope.CompanyProfile.StockFOC;
                }
                $scope.VoucherArray.push(temp53);

                var temp55 = {
                    Id: 55,
                    Name: "Stock JV",
                    NameVal: "Stock JV",
                    Type: "STOCK_JV"
                };
                if ($scope.CompanyProfile.StockJV != "" & $scope.CompanyProfile.StockJV != null) {
                    temp55.Name = $scope.CompanyProfile.StockJV;
                }
                $scope.VoucherArray.push(temp55);

                var temp56 = {
                    Id: 56,
                    Name: "Credit Note",
                    NameVal: "Credit Note",
                    Type: "CREDIT_NOTE"
                };
                if ($scope.CompanyProfile.CreditNote != "" & $scope.CompanyProfile.CreditNote != null) {
                    temp56.Name = $scope.CompanyProfile.CreditNote;
                }
                $scope.VoucherArray.push(temp56);

                var temp57 = {
                    Id: 57,
                    Name: "Debit Note",
                    NameVal: "Debit Note",
                    Type: "DEBIT_NOTE"
                };
                if ($scope.CompanyProfile.DebitNote != "" & $scope.CompanyProfile.DebitNote != null) {
                    temp57.Name = $scope.CompanyProfile.DebitNote;
                }
                $scope.VoucherArray.push(temp57);

                var temp58 = {
                    Id: 58,
                    Name: "Tenancy Contract",
                    NameVal: "Tenancy Contract",
                    Type: "Tenancy_Contract"
                };
                $scope.VoucherArray.push(temp58);

                var temp59 = {
                    Id: 59,
                    Name: "Purchase Tenancy Contract",
                    NameVal: "Purchase Tenancy Contract",
                    Type: "Tenancy_Contract"
                };
                $scope.VoucherArray.push(temp59);
                // console.log("$scope.VoucherArray",JSON.stringify($scope.VoucherArray));

                // Phase 1: Email Template Migration - Export VoucherArray to window object
                // Helper function to determine icon based on type
                function getIconForType(type) {
                    const iconMap = {
                        'SALES_INVOICE': 'receipt',
                        'SALES_INVOICE_2': 'receipt',
                        'SALES_INVOICE_3': 'receipt',
                        'SALES_INVOICE_4': 'receipt',
                        'INDIVIDUAL_SALES_INVOICE': 'receipt',
                        'DIRECT_SALES_INVOICE': 'receipt',
                        'EXPORT_SALES_INVOICE': 'receipt',
                        'SALES_QUOTATION': 'request_quote',
                        'SALES_QUOTATION_2': 'request_quote',
                        'SALES_QUOTATION_3': 'request_quote',
                        'SALES_QUOTATION_4': 'request_quote',
                        'SALES_ENQUIRY': 'help_outline',
                        'SALES_ENQUIRY_2': 'help_outline',
                        'SALES_ENQUIRY_3': 'help_outline',
                        'SALES_ENQUIRY_4': 'help_outline',
                        'SALES_ORDER': 'shopping_bag',
                        'SALES_ORDER_2': 'shopping_bag',
                        'SALES_ORDER_3': 'shopping_bag',
                        'SALES_ORDER_4': 'shopping_bag',
                        'SALES_RETURN': 'keyboard_return',
                        'DELIVERY_NOTE': 'local_shipping',
                        'DELIVERY_NOTE_2': 'local_shipping',
                        'DELIVERY_NOTE_3': 'local_shipping',
                        'DELIVERY_NOTE_4': 'local_shipping',
                        'PACKING_LIST': 'inventory_2',
                        'PROFORMA_INVOICE': 'description',
                        'PURCHASE_ORDER': 'shopping_cart',
                        'PURCHASE_INVOICE': 'inventory',
                        'DIRECT_PURCHASE_INVOICE': 'inventory',
                        'INDIVIDUAL_PURCHASE_INVOICE': 'inventory',
                        'IMPORT_PURCHASE_INVOICE': 'inventory',
                        'EXPORT_PURCHASE_INVOICE': 'inventory',
                        'PURCHASE_QUOTATION': 'request_quote',
                        'PURCHASE_ENQUIRY': 'help_outline',
                        'PURCHASE_REQUEST': 'assignment',
                        'PURCHASE_RETURN': 'keyboard_return',
                        'GOODS_RECEIVED': 'move_to_inbox',
                        'MATERIAL_REQUEST': 'assignment_turned_in',
                        'CASH_PAYMENT': 'payment',
                        'CASH_RECEIPT': 'account_balance_wallet',
                        'FUND_PAYMENT': 'payment',
                        'FUND_RECEIPT': 'account_balance_wallet',
                        'CHEQUE_PAYMENT': 'check',
                        'CHEQUE_RECEIPT': 'check_circle',
                        'JOURNAL_VOUCHER': 'book',
                        'OPENING_BALANCE': 'account_balance',
                        'COMPANY_EXPENSE': 'receipt_long',
                        'CREDIT_NOTE': 'credit_card',
                        'CREDIT_NOTE_SR': 'credit_card',
                        'DEBIT_NOTE': 'receipt_long',
                        'POS': 'point_of_sale',
                        'OPENING_STOCK': 'inventory',
                        'STOCK_RECEIVE': 'move_to_inbox',
                        'STOCK_ISSUE': 'outbox',
                        'STOCK_FOC': 'card_giftcard',
                        'STOCK_JV': 'swap_horiz'
                    };
                    return iconMap[type] || 'email';
                }

                // Helper function to determine module based on type
                function getModuleForType(type) {
                    if (type.startsWith('SALES_') || type.startsWith('INDIVIDUAL_SALES') || type.startsWith('DIRECT_SALES') || type.startsWith('EXPORT_SALES') || type.includes('DELIVERY_NOTE') || type === 'PACKING_LIST' || type === 'PROFORMA_INVOICE' || type === 'POS') return 'SALES';
                    if (type.startsWith('PURCHASE_') || type.startsWith('DIRECT_PURCHASE') || type.startsWith('INDIVIDUAL_PURCHASE') || type.startsWith('IMPORT_PURCHASE') || type.startsWith('EXPORT_PURCHASE') || type === 'GOODS_RECEIVED' || type === 'MATERIAL_REQUEST') return 'PURCH';
                    if (type.includes('PAYMENT') || type.includes('RECEIPT') || type.includes('JOURNAL') || type === 'OPENING_BALANCE' || type === 'COMPANY_EXPENSE' || type.includes('CREDIT_NOTE') || type.includes('DEBIT_NOTE')) return 'ACCNT';
                    if (type.includes('STOCK')) return 'INVTY';
                    return 'SETNG';
                }

                // Export VoucherArray to global window object for email template types
                if (typeof window !== 'undefined') {
                    window.MagtecEmailTemplateTypes = $scope.VoucherArray.map(function (voucher) {
                        return {
                            id: voucher.Id.toString(), // Convert to string for TypeScript compatibility
                            name: voucher.Type, // Maps to EmailTemplateType.Name
                            displayName: voucher.Name, // Maps to EmailTemplateType.DisplayName
                            description: 'Email template for ' + voucher.Name,
                            icon: getIconForType(voucher.Type),
                            module: getModuleForType(voucher.Type),
                            isActive: true,
                            // Keep original voucher data for reference
                            _originalVoucher: voucher
                        };
                    });

                    console.log("MagtecEmailTemplateTypes exported to window:", window.MagtecEmailTemplateTypes);
                }
            }

            $scope.checkMenuList = function () {
                if ($scope.TokenInfo.EmployeeId > 0) {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.GetUserSideMenu($scope.TokenInfo.UserId).then(function (response) {
                        if (response.data) {
                            $scope.SideMenu = response.data;
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                    });

                    MainService.GetUserTopMenu($scope.TokenInfo.UserId).then(function (response) {
                        if (response.data) {
                            $scope.TopMenu = response.data;
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                    });

                    MainService.GetUserMenuInSearch($scope.TokenInfo.UserId).then(function (response) {
                        if (response.data) {
                            $scope.SearchMenu = response.data;

                            if ($scope.SearchMenu.length > 0) {
                                var dataSource = new kendo.data.DataSource({
                                    data: $scope.SearchMenu,
                                    sort: {
                                        field: "Name",
                                        dir: "asc"
                                    }
                                });
                            } else {

                                var dataSource = new kendo.data.DataSource({
                                    data: $scope.PagesSearch,
                                    sort: {
                                        field: "Name",
                                        dir: "asc"
                                    }
                                });
                            }

                            $("#kd-place-chooser").kendoAutoComplete({
                                filter: "contains",
                                placeholder: 'Search here...',
                                dataTextField: "Name",
                                dataSource: dataSource,
                                select: function (data) {
                                    $state.go(data.dataItem.Link);
                                },
                            });


                        }
                    }, function (err) { });




                } else {

                    var dataSource = new kendo.data.DataSource({
                        data: $scope.PagesSearch,
                        sort: {
                            field: "Name",
                            dir: "asc"
                        }
                    });

                    $("#kd-place-chooser").kendoAutoComplete({
                        filter: "contains",
                        placeholder: 'Search here...',
                        dataTextField: "Name",
                        dataSource: dataSource,
                        select: function (data) {
                            $state.go(data.dataItem.Link);
                        },
                    });
                }
            }

            $scope.setMenuOpen = function (data) {
                if (data.IsOpen == true) {
                    data.IsOpen = false;
                } else {
                    data.IsOpen = true;
                }
            }

            $scope.InitMain = function () {

                $scope.TokenInfo = AuthenticationService.getTokenInfo();

                $scope.SideMenu = [];
                $scope.TopMenu = [];
                $scope.SearchMenu = [];

                if ($scope.TokenInfo != null && $scope.TokenInfo != undefined) {
                    $scope.checkMenuList();
                }



                if ($scope.TokenInfo != null) {
                    $scope.IsLoggedIn = true;
                } else {
                    $scope.IsLoggedIn = false;
                    $state.go("login");
                }

                $scope.mail = {
                    Name: "",
                    Email: "",
                    Subject: "",
                    Message: ""
                }

                $scope.enquiry = {
                    Name: "",
                    Email: "",
                    Subject: "",
                    Message: "",
                    MobNo: ""
                }

                $scope.mastersVal = false;
                $scope.warehouseVal = false;
                $scope.uploadVal = false;
                $scope.accountsVal = false;
                $scope.CostVal = false;
                $scope.inventoryVal = false;
                $scope.salesVouchersVal = false;
                $scope.possalesVouchersVal = false;
                $scope.CrmVal = false;
                $scope.TaskVal = false;
                $scope.OperationVal = false;
                $scope.PropertyVal = false;
                $scope.purchaseVouchersVal = false;
                $scope.basicVouchersVal = false;
                $scope.paymentVouchersVal = false;
                $scope.receiptVouchersVal = false;
                $scope.pdcVal = false;
                $scope.stocksVal = false;
                $scope.productionVal = false;
                $scope.docsVal = false;
                $scope.reportVal = false;
                $scope.toggleView = false;
                $scope.HRVal = false;
                $scope.AdvocateVal = false;
                $scope.contractVal = false;
                $scope.realestateVal = false;
                $scope.rentacarVal = false;
                $scope.dashboardVal = false;


                $scope.VoucherArray = [];
                $scope.messageWAP = "Hi this is from ";
                $scope.CompanyProfile = {};
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;
                    $scope.messageWAP = "Hi this is from " + $scope.CompanyProfile.Name + " for live Whatsaap support";
                    $scope.mail.Name = $scope.CompanyProfile.Name;
                    $scope.mail.Email = $scope.CompanyProfile.Email;

                    $scope.enquiry.Name = $scope.CompanyProfile.Name;
                    $scope.enquiry.Email = $scope.CompanyProfile.Email;
                    $scope.enquiry.MobNo = $scope.CompanyProfile.MobileNo;

                    $scope.UpdateVoucherNames();
                })


                $scope.Notifications = [];
                MainService.GetUserNotifications($scope.TokenInfo.UserId).then(function (response) {
                    $scope.Notifications = response.data;
                })


            }
            $scope.InitMain();



            $scope.WarehosueDesign = {};
            MainService.CustomDesignsbyType("Warehouse").then(function (response) {
                if (response.data != null && response.data != "") {
                    $scope.WarehosueDesign = response.data;
                } else {
                    $scope.WarehosueDesign = {};
                }
            }, function (err) {
            })

            $scope.goToWarehouseStockList = function (e) {
                $state.go("warehouseStockList", { Level: e });
            }

            $scope.goToWarehouseStockValuation = function (e) {
                $state.go("warehouseStockValuation", { Level: e });
            }

            $scope.initCCs = function () {
                $scope.CCParents = [];
                MainService.CostCenterList($scope.TokenInfo.UserId).then(function (response) {
                    $scope.CCParents = response.data;
                })
            }
            $scope.initCCs();

            $scope.goCostCenter = function (data) {
                $state.go("CostCenter", {
                    costId: data.Id,
                    costName: data.Name,
                })
            }


            $scope.getExtramasters = function () {

                $scope.isshowCustomerMore = false;

                //                $scope.CostCenters = {};
                //                MainService.GetAllCostCenters().then(function (response) {
                //                    $scope.CostCenters = response.data;
                //                });

                $scope.Units = [];
                MainService.UnitsInDropdown().then(function (response) {
                    $scope.Units = response.data;
                });

                $scope.VATs = [];
                MainService.VATsInDropdown().then(function (response) {
                    $scope.VATs = response.data;
                });


                $scope.Warehouses = [];
                MainService.WarehousesInDropdown().then(function (response) {
                    $scope.Warehouses = response.data;
                })


                $scope.Countries = [];
                MainService.CountriesInDropdown().then(function (response) {
                    $scope.Countries = response.data;
                })
                $scope.Brands = [];
                MainService.BrandsInDropdown().then(function (response) {
                    $scope.Brands = response.data;
                })
                $scope.Currencys = [];
                MainService.CurrencyInDropdown().then(function (response) {
                    $scope.Currencys = response.data;
                })
                $scope.Banks = [];
                MainService.BanksInDropdown().then(function (response) {
                    $scope.Banks = response.data;
                })
                $scope.Employees = [];
                MainService.EmployeesInDropdown().then(function (response) {
                    $scope.Employees = response.data;
                })
                $scope.master1s = [];
                MainService.Master1sInDropdown().then(function (response) {
                    $scope.master1s = response.data;
                });
                $scope.master2s = [];
                MainService.Master2sInDropdown().then(function (response) {
                    $scope.master2s = response.data;
                });
                $scope.master3s = [];
                MainService.Master3sInDropdown().then(function (response) {
                    $scope.master3s = response.data;
                });
                $scope.master4s = [];
                MainService.Master4sInDropdown().then(function (response) {
                    $scope.master4s = response.data;
                });
                $scope.master5s = [];
                MainService.Master5sInDropdown().then(function (response) {
                    $scope.master5s = response.data;
                });
                $scope.master6s = [];
                MainService.Master6sInDropdown().then(function (response) {
                    $scope.master6s = response.data;
                });
                $scope.master7s = [];
                MainService.Master7sInDropdown().then(function (response) {
                    $scope.master7s = response.data;
                });
                $scope.master8s = [];
                MainService.Master8sInDropdown().then(function (response) {
                    $scope.master8s = response.data;
                });
            }


            $scope.showMoreCustomer = function () {
                $scope.isshowCustomerMore = !$scope.isshowCustomerMore;
            }

            $scope.initFinks = function () {
                $scope.Favlinks = [];
                MainService.FavouritesByUser().then(function (response) {
                    $scope.Favlinks = response.data;
                }, function (err) {
                    console.log(err);
                })
            }
            $scope.initFinks();

            $scope.Levels = [{ Id: 1, Name: "1" }, { Id: 2, Name: "2" }, { Id: 3, Name: "3" }, { Id: 4, Name: "4" }, { Id: 5, Name: "5" }]

            $scope.InitLan = function () {

                $scope.Language = "EN";
                $scope.Direction = "ltr";
                $scope.MainContent = "main-content";
                $scope.brandClass = "brand";
                $scope.toggleClass = "sidebar-toggle-box";
                $scope.pullClass = "pull-right";
                $scope.notifyrowClass = "notify-row";
                $scope.padlclass = "";

                var lan = AuthenticationService.getlanInfo();
                if (lan != null) {
                    $scope.Language = lan;
                    if ($scope.Language == "AR") {
                        $scope.Direction = "rtl";
                        $scope.MainContent = "main-content2";
                        $scope.brandClass = "brand2";
                        $scope.toggleClass = "sidebar-toggle-box2";
                        $scope.pullClass = "pull-left";
                        $scope.notifyrowClass = "notify-row2";
                        $scope.padlclass = "padlclass";
                    }
                }

                $scope.LanguageData = LanguageService.getLanguageData($scope.Language);


            }
            $scope.InitLan();

            $scope.ChangeLanguage = function (data) {
                AuthenticationService.setLanInfo(data);
                $scope.InitLan();
            }

            $scope.refreshEmailSupport = function () {
                $scope.mail = {
                    Name: "",
                    Email: "",
                    Subject: "",
                    Message: ""
                }
                $scope.mail.Name = $scope.CompanyProfile.Name;
                $scope.mail.Email = $scope.CompanyProfile.Email;
            }

            $scope.SendEmailSupport = function () {

                var isEmailValid = true;
                var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

                if (reg.test($scope.mail.Email) == false) {
                    isEmailValid = false;
                }

                if (isEmailValid == false) {
                    toastr.warning("Enter Valid Email Address");
                } else if ($scope.mail.Subject == "") {
                    toastr.warning("Enter Subject");
                } else if ($scope.mail.Message == "") {
                    toastr.warning("Enter Message");
                } else {
                    $scope.Load = true;
                    MainService.SendEmailSupport($scope.mail).then(function (response) {
                        if (response.data) {
                            toastr.success("Email Send Success, We will connect you soon.");
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.Load = false;
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                    })
                }
            }

            $scope.refreshEnquiry = function () {
                $scope.enquiry = {
                    Name: "",
                    Email: "",
                    Subject: "",
                    Message: "",
                    MobNo: ""
                }

                $scope.enquiry.Name = $scope.CompanyProfile.Name;
                $scope.enquiry.Email = $scope.CompanyProfile.Email;
                $scope.enquiry.MobNo = $scope.CompanyProfile.MobileNo;
            }

            $scope.SendEnquiry = function () {

                var isEmailValid = true;
                var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

                if (reg.test($scope.enquiry.Email) == false) {
                    isEmailValid = false;
                }

                if (isEmailValid == false) {
                    toastr.warning("Enter Valid Email Address");
                } else if ($scope.enquiry.MobNo == "") {
                    toastr.warning("Enter Mobile No");
                } else if ($scope.enquiry.Subject == "") {
                    toastr.warning("Enter Subject");
                } else if ($scope.enquiry.Message == "") {
                    toastr.warning("Enter Message");
                } else {
                    $scope.Load = true;
                    MainService.SendEnquiry($scope.enquiry).then(function (response) {
                        if (response.data) {
                            toastr.success("Enquiry Send Success, We will connect you soon.");
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.Load = false;
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                    })
                }

            }

            $scope.goToReportPage = function (name, param) {
                $state.go(name, {
                    Type: param
                });
            }


            $scope.showHideMasters = function () {
                $scope.mastersVal = !$scope.mastersVal;
            }

            $scope.showHideWarehouses = function () {
                $scope.warehouseVal = !$scope.warehouseVal;
            }
            $scope.showHideAccounts = function () {
                $scope.accountsVal = !$scope.accountsVal;
            }
            $scope.showHideCosts = function () {
                $scope.CostVal = !$scope.CostVal;
            }
            $scope.showHideDashboards = function () {
                $scope.dashboardVal = !$scope.dashboardVal;
            }
            $scope.showHideUploads = function () {
                $scope.uploadVal = !$scope.uploadVal;
            }
            $scope.showHideInventories = function () {
                $scope.inventoryVal = !$scope.inventoryVal;
            }
            $scope.showHideHR = function () {
                $scope.HRVal = !$scope.HRVal;
            }
            $scope.showHidesalesVouchers = function () {
                $scope.salesVouchersVal = !$scope.salesVouchersVal;
            }
            $scope.showHidepossalesVouchers = function () {
                $scope.possalesVouchersVal = !$scope.possalesVouchersVal;
            }
            $scope.showHideCRN = function () {
                $scope.CrmVal = !$scope.CrmVal;
            }
            $scope.showHideTask = function () {
                $scope.TaskVal = !$scope.TaskVal;
            }
            $scope.showHideOperation = function () {
                $scope.OperationVal = !$scope.OperationVal;
            }
            $scope.showHideProperty = function () {
                $scope.PropertyVal = !$scope.PropertyVal;
            }
            $scope.showHidepurchaseVouchers = function () {
                $scope.purchaseVouchersVal = !$scope.purchaseVouchersVal;
            }
            $scope.showHideBasicVouchers = function () {
                $scope.basicVouchersVal = !$scope.basicVouchersVal;
            }
            $scope.showHidePaymentVouchers = function () {
                $scope.paymentVouchersVal = !$scope.paymentVouchersVal;
            }
            $scope.showHideReceiptVouchers = function () {
                $scope.receiptVouchersVal = !$scope.receiptVouchersVal;
            }
            $scope.showHidePDCs = function () {
                $scope.pdcVal = !$scope.pdcVal;
            }
            $scope.showHideReports = function () {
                $scope.reportVal = !$scope.reportVal;
            }
            $scope.showHideStocks = function () {
                $scope.stocksVal = !$scope.stocksVal;
            }
            $scope.showHideProduction = function () {
                $scope.productionVal = !$scope.productionVal;
            }
            $scope.showHideDocs = function () {
                $scope.docsVal = !$scope.docsVal;
            }
            $scope.showHideAdvocate = function () {
                $scope.AdvocateVal = !$scope.AdvocateVal;
            }
            $scope.showHideContracts = function () {
                $scope.contractVal = !$scope.contractVal;
            }

            $scope.showHideRealEstate = function () {
                $scope.realestateVal = !$scope.realestateVal;
            }
            $scope.showHideRentaCar = function () {
                $scope.rentacarVal = !$scope.rentacarVal;
            }

            $scope.logOut = function () {
                var token = AuthenticationService.getTokenInfo();
                $scope.working = true;
                LoginService.logOut(token)
                    .then(function (response) {
                        $scope.working = false;
                        if (response) {
                            AuthenticationService.removeTokenInfo();
                            $scope.IsLoggedIn = false;
                            $scope.InitMain();
                            $state.go("login");
                        }
                    }, function (err) {
                        $scope.working = false;
                    })
            };

            $scope.ViewBillDetails = function (voucherId, Type) {
                if (!$scope.PageAccessInfo.IsView) {
                    toastr.info("You Dont Have Access To View Data, Please Contact Admin");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.GetVoucherBillDetails(voucherId, Type).then(function (response) {
                        if (response) {
                            $scope.BillData = response.data;
                            $('#billDetModal').modal('show');
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                    })

                }
            }

            $scope.ViewGl = function (voucherId, Type) {
                if (!$scope.PageAccessInfo.IsView) {
                    toastr.info("You Dont Have Access To View Data, Please Contact Admin");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.ViewIndividualLedgers(voucherId, Type).then(function (response) {
                        if (response) {
                            $scope.GLData = response.data;
                            $scope.TotalDebit = 0;
                            $scope.TotalCredit = 0;
                            angular.forEach($scope.GLData, function (e) {
                                $scope.TotalDebit = $scope.TotalDebit + e.Debit;
                                $scope.TotalDebit = Math.round($scope.TotalDebit * 100) / 100;
                                $scope.TotalCredit = $scope.TotalCredit + e.Credit;
                                $scope.TotalCredit = Math.round($scope.TotalCredit * 100) / 100;
                                $scope.BalanceGL = Math.round(($scope.TotalDebit - $scope.TotalCredit) * 100) / 100;
                            })
                            $('#glModal').modal('show');
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                    })

                }
            }

            $scope.ViewSl = function (voucherId, Type, VNum) {
                if (!$scope.PageAccessInfo.IsView) {
                    toastr.info("You Dont Have Access To View Data, Please Contact Admin");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.ViewIndividualStockLedgers(voucherId, Type).then(function (response) {
                        if (response) {
                            $scope.SLData = response.data;
                            $('#slModal').modal('show');
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                    })

                }
            }

            $scope.GetVoucherApprovalHistory = function (voucherId, VNum, Vname) {

                $scope.VoucherApprovalList = [];

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetVoucherApprovalHistory(voucherId, VNum, Vname).then(function (response) {
                    if (response) {
                        $scope.VoucherApprovalList = response.data;
                        $('#approvalHistortModal').modal('show');
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                })
            }

            $scope.PrintInvoice = function (voucherId, Type, voucherno) {
                if (!$scope.PageAccessInfo.IsPrint) {
                    toastr.info("You Dont Have Access To Print Data, Please Contact Admin");
                } else {

                    $scope.Load = true;
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    var data = {
                        PrintType: Type,
                        PrintId: voucherId,
                        VoucherNo: voucherno,
                    }
                    MainService.PrintInvoice(data).then(function (response) {
                        if (response.data != null) {
                            $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    })

                }
            }

            $scope.PrintRentACarInvoice = function (voucherId) {
                if (!$scope.PageAccessInfo.IsPrint) {
                    toastr.info("You Dont Have Access To Print Data, Please Contact Admin");
                } else {

                    $scope.Load = true;

                    MainService.PrintSalesInvoiceCarContrct(voucherId).then(function (response) {
                        if (response.data != null) {
                            $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.Load = false;
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                    })

                }
            }

            $scope.SaveAuditDone = function (voucherId, Type, voucher) {
                $scope.Load = true;

                MainService.SaveAuditDone(voucherId, Type).then(function (response) {
                    if (response.data != null) {
                        voucher.IsAudit = true;
                        toastr.success("Success");
                    } else {
                        toastr.error("Failed");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


            $scope.UserUpdate = {
                Password: "",
                CPassword: ""
            }

            $scope.changePassword = function () {

                if ($scope.UserUpdate.Password == "") {
                    toastr.error("Enter Password");
                } else if ($scope.UserUpdate.CPassword == "") {
                    toastr.error("Confirm Password");
                } else if ($scope.UserUpdate.Password != $scope.UserUpdate.CPassword) {
                    toastr.error("Password not matching");
                } else {
                    $scope.Load = true;
                    MainService.ChangePassword($scope.UserUpdate).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $scope.UserUpdate = {
                                Password: "",
                                CPassword: ""
                            }
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.Load = false;
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                    })

                }

            }

            //////////////////// VoucherDocs ////////////////////

            $scope.goVoucherDocs = function (voucher, type) {
                $state.go("voucherDocs", {
                    VoucherType: type,
                    VoucherNo: voucher.VoucherNumber,
                    VoucherId: voucher.Id,
                })
            }

            //////////////////// Linking ////////////////////

            $scope.LinkPreviewData = {};

            $scope.linkVoucherModal = function (data, type) {
                $scope.LinkVoucher = data;
                $scope.LinkVoucherType = type;

                $scope.VoucherLinks = [];
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.VoucherLinksInVoucher(type).then(function (response) {
                    $scope.VoucherLinks = response.data;
                    $.LoadingOverlay("hide");
                    $('#linkVoucherModal').modal('show');
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.LinkToVoucher = function (link) {
                console.log(link);
                if (link == "Sales Enquiry") {
                    $state.go("linkSalesEnquiry", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Quotation") {
                    $state.go("linkSalesQuotation", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Order") {
                    $state.go("linkSalesOrder", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Packing List") {
                    $state.go("linkPackingList", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Delivery Note") {
                    $state.go("linkDeliveryNote", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Invoice") {
                    $state.go("linkSalesInvoice", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Direct Sales Invoice") {
                    $state.go("linkDirSalesInvoice", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Export Sales Invoice") {
                    $state.go("linkExpSalesInvoice", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Proforma Invoice") {
                    $state.go("linkPorSalesInvoice", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Return") {
                    $state.go("linkSalesReturn", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Credit Note SR") {
                    $state.go("linkCreditNoteSR", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Material Request") {
                    $state.go("linkMaterialRequest", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Purchase Request") {
                    $state.go("linkPurchaseRequest", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Purchase Enquiry") {
                    $state.go("linkPurchaseEnquiry", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Purchase Quotation") {
                    $state.go("linkPurchaseQuotation", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Purchase Order") {
                    $state.go("linkPurchaseOrder", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Goods Received") {
                    $state.go("linkGoodsReceived", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Purchase Invoice") {
                    $state.go("linkPurchaseInvoice", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Direct Purchase Invoice") {
                    $state.go("linkDirPurchaseInvoice", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Individual Purchase Invoice") {
                    $state.go("linkIndPurchaseInvoice", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Individual Sales Invoice") {
                    $state.go("linkIndSalesInvoice", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Import Purchase Invoice") {
                    $state.go("linkImpPurchaseInvoice", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Export Purchase Invoice") {
                    $state.go("linkExpPurchaseInvoice", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Purchase Return") {
                    $state.go("linkPurchaseReturn", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Enquiry 2") {
                    $state.go("linkSalesEnquiry2", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Enquiry 3") {
                    $state.go("linkSalesEnquiry3", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Enquiry 4") {
                    $state.go("linkSalesEnquiry4", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Quotation 2") {
                    $state.go("linkSalesQuotation2", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Quotation 3") {
                    $state.go("linkSalesQuotation3", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Quotation 4") {
                    $state.go("linkSalesQuotation4", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Order 2") {
                    $state.go("linkSalesOrder2", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Order 3") {
                    $state.go("linkSalesOrder3", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Order 4") {
                    $state.go("linkSalesOrder4", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Delivery Note 2") {
                    $state.go("linkDeliveryNote2", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Delivery Note 3") {
                    $state.go("linkDeliveryNote3", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Delivery Note 4") {
                    $state.go("linkDeliveryNote4", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Invoice 2") {
                    $state.go("linkSalesInvoice2", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Invoice 3") {
                    $state.go("linkSalesInvoice3", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                } else if (link == "Sales Invoice 4") {
                    $state.go("linkSalesInvoice4", {
                        LinkVoucherId: $scope.LinkVoucher.Id,
                        VoucherType: $scope.LinkVoucherType
                    })
                }
                $('#linkVoucherModal').modal('hide');

            }



            $scope.selectedCostAdd = {};
            $scope.addCostCenterDir = function (data) {
                $scope.selectedCostAdd = data;
                $scope.DirCostCenter = {
                    Name: "",
                    Level: 1,
                    Description: "",
                    Address: "",
                    Code: "",
                    ParentId: data.Id,
                    IsActive: true,
                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",
                    Field11: "",
                    Field12: "",
                    Field13: "",
                    Field14: "",
                    Field15: "",
                    Field16: null,
                    Field17: null,
                    Field18: null,
                    Field19: null,
                    Field20: null,
                }


                $scope.DirCostDesign = {};
                MainService.GetCostCenterDesign(data.Id).then(function (response) {
                    if (response.data != null) {
                        $scope.DirCostDesign = response.data;
                    } else {
                        $scope.DirCostDesign = {};
                    }

                    if ($scope.DirCostDesign.IsAutoCode) {

                        MainService.GetNextCoseCenterNo($scope.selectedCostAdd.Name).then(function (response) {
                            $scope.DirCostCenter.Code = response.data;
                        })

                    }

                    if ($scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                        var data = {
                            PageName: "Cost Center",
                            UserId: $scope.TokenInfo.UserId,
                        }
                        MainService.CheckUserPageAccess(data).then(function (response) {
                            if (response.data != null) {
                                $('#addCostModal').modal('show');
                            } else {
                                toastr.warning("Adding Cost Center Not Allowed To You!");
                            }
                        }, function (err) {
                            toastr.error($scope.NetworkErrorLan);
                        });
                    } else {
                        $('#addCostModal').modal('show');
                    }




                }, function (err) {
                    $scope.load = false;
                });


            }

            $scope.saveCostCenterDir = function () {

                if ($scope.DirCostCenter.Name == "") {
                    toastr.warning("Give Cost Center Name");
                } else if ($scope.DirCostCenter.Code == "") {
                    toastr.warning("Give Cost Center Code");
                } else if ($scope.DirCostCenter.Description == "" && $scope.DirCostDesign.IsDescriptionMandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter Description");
                } else if ($scope.DirCostCenter.Address == "" && $scope.DirCostDesign.IsAddressMandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter Address");
                } else if ($scope.DirCostCenter.Field1 == "" && $scope.DirCostDesign.IsField1Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field1);
                } else if ($scope.DirCostCenter.Field2 == "" && $scope.DirCostDesign.IsField2Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field2);
                } else if ($scope.DirCostCenter.Field3 == "" && $scope.DirCostDesign.IsField3Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field3);
                } else if ($scope.DirCostCenter.Field4 == "" && $scope.DirCostDesign.IsField4Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field4);
                } else if ($scope.DirCostCenter.Field5 == "" && $scope.DirCostDesign.IsField5Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field5);
                } else if ($scope.DirCostCenter.Field6 == "" && $scope.DirCostDesign.IsField6Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field6);
                } else if ($scope.DirCostCenter.Field7 == "" && $scope.DirCostDesign.IsField7Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field7);
                } else if ($scope.DirCostCenter.Field8 == "" && $scope.DirCostDesign.IsField8Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field8);
                } else if ($scope.DirCostCenter.Field9 == "" && $scope.DirCostDesign.IsField9Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field9);
                } else if ($scope.DirCostCenter.Field10 == "" && $scope.DirCostDesign.IsField10Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field10);
                } else if ($scope.DirCostCenter.Field11 == "" && $scope.DirCostDesign.IsField11Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field11);
                } else if ($scope.DirCostCenter.Field12 == "" && $scope.DirCostDesign.IsField12Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field12);
                } else if ($scope.DirCostCenter.Field13 == "" && $scope.DirCostDesign.IsField13Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field13);
                } else if ($scope.DirCostCenter.Field14 == "" && $scope.DirCostDesign.IsField14Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field14);
                } else if ($scope.DirCostCenter.Field15 == "" && $scope.DirCostDesign.IsField15Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field15);
                } else if ($scope.DirCostCenter.Field16 == null && $scope.DirCostDesign.IsField16Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field16);
                } else if ($scope.DirCostCenter.Field17 == null && $scope.DirCostDesign.IsField17Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field17);
                } else if ($scope.DirCostCenter.Field18 == null && $scope.DirCostDesign.IsField18Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field18);
                } else if ($scope.DirCostCenter.Field19 == null && $scope.DirCostDesign.IsField19Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field19);
                } else if ($scope.DirCostCenter.Field20 == null && $scope.DirCostDesign.IsField20Mandatory && $scope.DirCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.DirCostDesign.Field20);
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddCostCenter($scope.DirCostCenter).then(function (response) {
                        $scope.load = false;
                        if (response.data == "Success") {
                            toastr.success("Cost Center Saved");
                            $("#addCostModal").modal("hide");
                            $scope.$broadcast('refreshCostCenterDir', $scope.DirCostCenter.ParentId);
                            $scope.DirCostCenter = {
                                Name: "",
                                Level: 1,
                                Description: "",
                                Code: "",
                                ParentId: "",
                                Address: "",
                                IsActive: true,
                                Field1: "",
                                Field2: "",
                                Field3: "",
                                Field4: "",
                                Field5: "",
                                Field6: "",
                                Field7: "",
                                Field8: "",
                                Field9: "",
                                Field10: "",
                                Field11: "",
                                Field12: "",
                                Field13: "",
                                Field14: "",
                                Field15: "",
                                Field16: null,
                                Field17: null,
                                Field18: null,
                                Field19: null,
                                Field20: null,
                            }
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });
                }


            }

            $scope.selectedMaster = {};
            $scope.addMasterDir = function (data, type) {

                $scope.selectedMaster = {
                    type: type,
                    Name: data,
                };

                if (type == "master1") {
                    $scope.selectedMaster.Feild1Name = $scope.CompanyProfile.Master1Feild1;
                    $scope.selectedMaster.Feild2Name = $scope.CompanyProfile.Master1Feild2;
                    $scope.selectedMaster.Feild3Name = $scope.CompanyProfile.Master1Feild3;
                    $scope.selectedMaster.Feild4Name = $scope.CompanyProfile.Master1Feild4;
                    $scope.selectedMaster.Feild5Name = $scope.CompanyProfile.Master1Feild5;
                    $scope.selectedMaster.Feild6Name = $scope.CompanyProfile.Master1Feild6;
                    $scope.selectedMaster.Feild7Name = $scope.CompanyProfile.Master1Feild7;
                    $scope.selectedMaster.Feild8Name = $scope.CompanyProfile.Master1Feild8;
                    $scope.selectedMaster.Feild9Name = $scope.CompanyProfile.Master1Feild9;
                    $scope.selectedMaster.Feild10Name = $scope.CompanyProfile.Master1Feild10;
                } else if (type == "master2") {
                    $scope.selectedMaster.Feild1Name = $scope.CompanyProfile.Master2Feild1;
                    $scope.selectedMaster.Feild2Name = $scope.CompanyProfile.Master2Feild2;
                    $scope.selectedMaster.Feild3Name = $scope.CompanyProfile.Master2Feild3;
                    $scope.selectedMaster.Feild4Name = $scope.CompanyProfile.Master2Feild4;
                    $scope.selectedMaster.Feild5Name = $scope.CompanyProfile.Master2Feild5;
                    $scope.selectedMaster.Feild6Name = $scope.CompanyProfile.Master2Feild6;
                    $scope.selectedMaster.Feild7Name = $scope.CompanyProfile.Master2Feild7;
                    $scope.selectedMaster.Feild8Name = $scope.CompanyProfile.Master2Feild8;
                    $scope.selectedMaster.Feild9Name = $scope.CompanyProfile.Master2Feild9;
                    $scope.selectedMaster.Feild10Name = $scope.CompanyProfile.Master2Feild10;
                } else if (type == "master3") {
                    $scope.selectedMaster.Feild1Name = $scope.CompanyProfile.Master3Feild1;
                    $scope.selectedMaster.Feild2Name = $scope.CompanyProfile.Master3Feild2;
                    $scope.selectedMaster.Feild3Name = $scope.CompanyProfile.Master3Feild3;
                    $scope.selectedMaster.Feild4Name = $scope.CompanyProfile.Master3Feild4;
                    $scope.selectedMaster.Feild5Name = $scope.CompanyProfile.Master3Feild5;
                    $scope.selectedMaster.Feild6Name = $scope.CompanyProfile.Master3Feild6;
                    $scope.selectedMaster.Feild7Name = $scope.CompanyProfile.Master3Feild7;
                    $scope.selectedMaster.Feild8Name = $scope.CompanyProfile.Master3Feild8;
                    $scope.selectedMaster.Feild9Name = $scope.CompanyProfile.Master3Feild9;
                    $scope.selectedMaster.Feild10Name = $scope.CompanyProfile.Master3Feild10;
                } else if (type == "master4") {
                    $scope.selectedMaster.Feild1Name = $scope.CompanyProfile.Master4Feild1;
                    $scope.selectedMaster.Feild2Name = $scope.CompanyProfile.Master4Feild2;
                    $scope.selectedMaster.Feild3Name = $scope.CompanyProfile.Master4Feild3;
                    $scope.selectedMaster.Feild4Name = $scope.CompanyProfile.Master4Feild4;
                    $scope.selectedMaster.Feild5Name = $scope.CompanyProfile.Master4Feild5;
                    $scope.selectedMaster.Feild6Name = $scope.CompanyProfile.Master4Feild6;
                    $scope.selectedMaster.Feild7Name = $scope.CompanyProfile.Master4Feild7;
                    $scope.selectedMaster.Feild8Name = $scope.CompanyProfile.Master4Feild8;
                    $scope.selectedMaster.Feild9Name = $scope.CompanyProfile.Master4Feild9;
                    $scope.selectedMaster.Feild10Name = $scope.CompanyProfile.Master4Feild10;
                } else if (type == "master5") {
                    $scope.selectedMaster.Feild1Name = $scope.CompanyProfile.Master5Feild1;
                    $scope.selectedMaster.Feild2Name = $scope.CompanyProfile.Master5Feild2;
                    $scope.selectedMaster.Feild3Name = $scope.CompanyProfile.Master5Feild3;
                    $scope.selectedMaster.Feild4Name = $scope.CompanyProfile.Master5Feild4;
                    $scope.selectedMaster.Feild5Name = $scope.CompanyProfile.Master5Feild5;
                    $scope.selectedMaster.Feild6Name = $scope.CompanyProfile.Master5Feild6;
                    $scope.selectedMaster.Feild7Name = $scope.CompanyProfile.Master5Feild7;
                    $scope.selectedMaster.Feild8Name = $scope.CompanyProfile.Master5Feild8;
                    $scope.selectedMaster.Feild9Name = $scope.CompanyProfile.Master5Feild9;
                    $scope.selectedMaster.Feild10Name = $scope.CompanyProfile.Master5Feild10;
                } else if (type == "master6") {
                    $scope.selectedMaster.Feild1Name = $scope.CompanyProfile.Master6Feild1;
                    $scope.selectedMaster.Feild2Name = $scope.CompanyProfile.Master6Feild2;
                    $scope.selectedMaster.Feild3Name = $scope.CompanyProfile.Master6Feild3;
                    $scope.selectedMaster.Feild4Name = $scope.CompanyProfile.Master6Feild4;
                    $scope.selectedMaster.Feild5Name = $scope.CompanyProfile.Master6Feild5;
                    $scope.selectedMaster.Feild6Name = $scope.CompanyProfile.Master6Feild6;
                    $scope.selectedMaster.Feild7Name = $scope.CompanyProfile.Master6Feild7;
                    $scope.selectedMaster.Feild8Name = $scope.CompanyProfile.Master6Feild8;
                    $scope.selectedMaster.Feild9Name = $scope.CompanyProfile.Master6Feild9;
                    $scope.selectedMaster.Feild10Name = $scope.CompanyProfile.Master6Feild10;
                } else if (type == "master7") {
                    $scope.selectedMaster.Feild1Name = $scope.CompanyProfile.Master7Feild1;
                    $scope.selectedMaster.Feild2Name = $scope.CompanyProfile.Master7Feild2;
                    $scope.selectedMaster.Feild3Name = $scope.CompanyProfile.Master7Feild3;
                    $scope.selectedMaster.Feild4Name = $scope.CompanyProfile.Master7Feild4;
                    $scope.selectedMaster.Feild5Name = $scope.CompanyProfile.Master7Feild5;
                    $scope.selectedMaster.Feild6Name = $scope.CompanyProfile.Master7Feild6;
                    $scope.selectedMaster.Feild7Name = $scope.CompanyProfile.Master7Feild7;
                    $scope.selectedMaster.Feild8Name = $scope.CompanyProfile.Master7Feild8;
                    $scope.selectedMaster.Feild9Name = $scope.CompanyProfile.Master7Feild9;
                    $scope.selectedMaster.Feild10Name = $scope.CompanyProfile.Master7Feild10;
                } else if (type == "master8") {
                    $scope.selectedMaster.Feild1Name = $scope.CompanyProfile.Master8Feild1;
                    $scope.selectedMaster.Feild2Name = $scope.CompanyProfile.Master8Feild2;
                    $scope.selectedMaster.Feild3Name = $scope.CompanyProfile.Master8Feild3;
                    $scope.selectedMaster.Feild4Name = $scope.CompanyProfile.Master8Feild4;
                    $scope.selectedMaster.Feild5Name = $scope.CompanyProfile.Master8Feild5;
                    $scope.selectedMaster.Feild6Name = $scope.CompanyProfile.Master8Feild6;
                    $scope.selectedMaster.Feild7Name = $scope.CompanyProfile.Master8Feild7;
                    $scope.selectedMaster.Feild8Name = $scope.CompanyProfile.Master8Feild8;
                    $scope.selectedMaster.Feild9Name = $scope.CompanyProfile.Master8Feild9;
                    $scope.selectedMaster.Feild10Name = $scope.CompanyProfile.Master8Feild10;
                }

                $scope.msaterObj = {
                    Name: "",
                    IsActive: true,
                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",
                }

                $('#addMasterModal').modal('show');

            }

            $scope.initDirMasterObj = function () {
                $scope.msaterObj = {
                    Name: "",
                    IsActive: true,
                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",
                }
            }

            $scope.AddMsaterObj = function () {
                console.log($scope.selectedMaster);
                if ($scope.msaterObj.Name == "") {
                    toastr.warning("Enter Name");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    if ($scope.selectedMaster.type == "master1") {
                        MainService.AddMaster1($scope.msaterObj).then(function (response) {
                            if (response.data == "Success") {
                                toastr.success("Success");
                                $scope.initDirMasterObj();
                                $scope.master1s = [];
                                MainService.Master1sInDropdown().then(function (response) {
                                    $scope.master1s = response.data;
                                });
                                $('#addMasterModal').modal('hide');
                            } else {
                                toastr.error(response.data);
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        });
                    } else if ($scope.selectedMaster.type == "master2") {
                        MainService.AddMaster2($scope.msaterObj).then(function (response) {
                            if (response.data == "Success") {
                                toastr.success("Success");
                                $scope.initDirMasterObj();
                                $scope.master2s = [];
                                MainService.Master2sInDropdown().then(function (response) {
                                    $scope.master2s = response.data;
                                });
                                $('#addMasterModal').modal('hide');
                            } else {
                                toastr.error(response.data);
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        });
                    } else if ($scope.selectedMaster.type == "master3") {
                        MainService.AddMaster3($scope.msaterObj).then(function (response) {
                            if (response.data == "Success") {
                                toastr.success("Success");
                                $scope.initDirMasterObj();
                                $scope.master3s = [];
                                MainService.Master3sInDropdown().then(function (response) {
                                    $scope.master3s = response.data;
                                });
                                $('#addMasterModal').modal('hide');
                            } else {
                                toastr.error(response.data);
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        });
                    } else if ($scope.selectedMaster.type == "master4") {
                        MainService.AddMaster4($scope.msaterObj).then(function (response) {
                            if (response.data == "Success") {
                                toastr.success("Success");
                                $scope.initDirMasterObj();
                                $scope.master4s = [];
                                MainService.Master4sInDropdown().then(function (response) {
                                    $scope.master4s = response.data;
                                });
                                $('#addMasterModal').modal('hide');
                            } else {
                                toastr.error(response.data);
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        });
                    } else if ($scope.selectedMaster.type == "master5") {
                        MainService.AddMaster5($scope.msaterObj).then(function (response) {
                            if (response.data == "Success") {
                                toastr.success("Success");
                                $scope.initDirMasterObj();
                                $scope.master5s = [];
                                MainService.Master5sInDropdown().then(function (response) {
                                    $scope.master5s = response.data;
                                });
                                $('#addMasterModal').modal('hide');
                            } else {
                                toastr.error(response.data);
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        });
                    } else if ($scope.selectedMaster.type == "master6") {
                        MainService.AddMaster6($scope.msaterObj).then(function (response) {
                            if (response.data == "Success") {
                                toastr.success("Success");
                                $scope.initDirMasterObj();
                                $scope.master6s = [];
                                MainService.Master6sInDropdown().then(function (response) {
                                    $scope.master6s = response.data;
                                });
                                $('#addMasterModal').modal('hide');
                            } else {
                                toastr.error(response.data);
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        });
                    } else if ($scope.selectedMaster.type == "master7") {
                        MainService.AddMaster7($scope.msaterObj).then(function (response) {
                            if (response.data == "Success") {
                                toastr.success("Success");
                                $scope.initDirMasterObj();
                                $scope.master7s = [];
                                MainService.Master7sInDropdown().then(function (response) {
                                    $scope.master7s = response.data;
                                });
                                $('#addMasterModal').modal('hide');
                            } else {
                                toastr.error(response.data);
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        });
                    } else if ($scope.selectedMaster.type == "master8") {
                        MainService.AddMaster8($scope.msaterObj).then(function (response) {
                            if (response.data == "Success") {
                                toastr.success("Success");
                                $scope.initDirMasterObj();
                                $scope.master8s = [];
                                MainService.Master8sInDropdown().then(function (response) {
                                    $scope.master8s = response.data;
                                });
                                $('#addMasterModal').modal('hide');
                            } else {
                                toastr.error(response.data);
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        });
                    }



                }

            }

            /////////////////// EXTRA AUTO COMPLETE //////////////////

            $scope.DirCostFieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.CostcenterFieldAutoComplete(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.DirCostFieldAutoCompleteOptions11 = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.DirCostCenter.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DirCostFieldAutoCompleteDataSource
            };

            $scope.DirCostFieldAutoCompleteOptions12 = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.DirCostCenter.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DirCostFieldAutoCompleteDataSource
            };

            $scope.DirCostFieldAutoCompleteOptions13 = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.DirCostCenter.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DirCostFieldAutoCompleteDataSource
            };

            $scope.DirCostFieldAutoCompleteOptions14 = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.DirCostCenter.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DirCostFieldAutoCompleteDataSource
            };

            $scope.DirCostFieldAutoCompleteOptions15 = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.DirCostCenter.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DirCostFieldAutoCompleteDataSource
            };

            /////////////////// END EXTRA AUTO COMPLETE //////////////////

            /////////////////// Direct Product //////////////////

            $scope.addProdDir = function () {
                $scope.DirProduct = {
                    Name: "",
                    NameAr: "",
                    ProductCode: "",
                    ParentId: "",
                    IsActive: true,
                    IsGroup: true,
                    Level: 3,
                    ProductType: "Product",
                    BarCode: "",
                    Specification: "",
                    Model: "",
                    Description: "",
                    SupplierName: "",
                    DepreciationYear: "",
                    AMCCompany: "",
                    SellPrice: 0,
                    PurchasePrice: 0,
                    WarrantyDate: "",
                    UnitId: "",
                    CountryId: "",
                    manufacturing: "",
                    YRRefNo: "",
                    Stock: "",
                    VATId: "",
                    SalesAccountId: "",
                    PurchaseAccountId: "",
                    Image: "",
                    VatType: "Exclusive",
                    CategoryId: "",
                    BrandId: ""
                }

                $scope.ViewVal2 = 0;

                $scope.DirProduct.VATId = $scope.CompanyProfile.DefaultVATId;
                $scope.DirProduct.UnitId = $scope.CompanyProfile.DefaultUnitId;


                $scope.ProductDesign = {};
                MainService.GetProductDesign().then(function (response) {
                    $scope.ProductDesign = response.data;
                }, function (err) { })


                if ($scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    var data = {
                        PageName: "Add Product",
                        UserId: $scope.TokenInfo.UserId,
                    }
                    MainService.CheckUserPageAccess(data).then(function (response) {
                        if (response.data != null) {
                            $('#addProductModal').modal('show');
                        } else {
                            toastr.warning("Adding Product Not Allowed To You!");
                        }
                    }, function (err) {
                        toastr.error($scope.NetworkErrorLan);
                    });
                } else {
                    $('#addProductModal').modal('show');
                }





                MainService.VATsInDropdown().then(function (response) {
                    $scope.Vats = response.data;
                });

                MainService.UnitsInDropdown().then(function (response) {
                    $scope.Units = response.data;
                });

                MainService.CountriesInDropdown().then(function (response) {
                    $scope.Countries = response.data;
                });

                MainService.BrandsInDropdown().then(function (response) {
                    $scope.Brands = response.data;
                });

                $scope.Categories = [];
                MainService.ProductsParentList("Product").then(function (response) {
                    $scope.Categories = response.data;
                    if (response.data.length > 0) {
                        $scope.DirProduct.CategoryId = $scope.Categories[0].Id;
                        $scope.GetSubProduct();
                    }
                });
            }

            $scope.GetSubProduct = function () {
                $scope.Parents = [];
                MainService.ProductSubList($scope.DirProduct.CategoryId, "Product").then(function (response) {
                    $scope.Parents = response.data;
                });
            }

            $scope.DirAccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        MainService.accountInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("Network Error");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.DirPurchaseAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.DirProduct.PurchaseAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DirAccountAutocompleteDataSource
            };

            $scope.DirSalesAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.DirProduct.SalesAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DirAccountAutocompleteDataSource
            };

            $scope.copyProductDir = function () {
                if ($scope.CompanyProfile.IsProductRemarksCopy) {
                    $scope.DirProduct.Description = angular.copy($scope.DirProduct.Name);
                }
            }

            $scope.adddirProduct = function () {

                if ($scope.DirProduct.Name == "") {
                    toastr.warning("Give Name");
                } else if ($scope.DirProduct.ProductCode == "" && !$scope.CompanyProfile.IsAutoProductCode) {
                    toastr.warning("Give Code");
                } else if ($scope.DirProduct.VATId == "") {
                    toastr.warning("Select VAT");
                } else if ($scope.DirProduct.UnitId == "") {
                    toastr.warning("Select Unit");
                } else if ($scope.DirProduct.VATId == "") {
                    toastr.warning("Select Vat");
                } else {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddProduct($scope.DirProduct).then(function (response) {
                        $scope.load = false;
                        if (response.data == "Success") {
                            toastr.success("Saved");
                            $('#addProductModal').modal('hide');
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });
                }
            }

            $scope.extractDate = function (date) {
                if (typeof date === 'string' || date instanceof String) {
                    date = new Date(date);
                }
                var Month = date.getMonth() + 1;
                Month = Month.toString();
                if (Month.length == 1) {
                    Month = '0' + Month;
                }
                var Day = date.getDate();
                Day = Day.toString();
                if (Day.length == 1) {
                    Day = '0' + Day;
                }
                var Year = date.getFullYear();
                Year = Year.toString();
                var newDate = Day + "/" + Month + "/" + Year;
                return newDate;
            }


            $scope.extractDateTime = function (date) {
                if (typeof date === 'string' || date instanceof String) {
                    date = new Date(date);
                }
                var Month = date.getMonth() + 1;
                Month = Month.toString();
                if (Month.length == 1) {
                    Month = '0' + Month;
                }
                var Day = date.getDate();
                Day = Day.toString();
                if (Day.length == 1) {
                    Day = '0' + Day;
                }
                var Year = date.getFullYear();
                Year = Year.toString();

                var Hours = date.getHours();
                Hours = Hours.toString();
                if (Hours.length == 1) {
                    Hours = '0' + Hours;
                }

                var Minutes = date.getMinutes();
                Minutes = Minutes.toString();
                if (Minutes.length == 1) {
                    Minutes = '0' + Minutes;
                }

                var newDate = Day + "/" + Month + "/" + Year + " " + Hours + ":" + Minutes;
                return newDate;
            }

            $scope.showRemarksModel = function (data, design, temp, IsRemarksSmall) {
                $scope.SelectedCE = data;
                $scope.SelectedDesign = design;
                $scope.IsRemarksSmall2 = IsRemarksSmall;
                if (temp == 1) {
                    $('#remarksModel2').modal('show');
                } else {
                    $('#remarksModel').modal('show');
                }

            }

            $scope.gotoProductedit = function (id) {
                if (id > 0) {
                    var url = $state.href("editProduct", {
                        ItemId: id
                    }, {
                        absolute: true
                    });
                    window.open(url, '_blank');
                }
            }

            $scope.TimeArray = [
                {
                    Name: "00"
                },
                {
                    Name: "01"
                },
                {
                    Name: "02"
                },
                {
                    Name: "03"
                },
                {
                    Name: "04"
                },
                {
                    Name: "05"
                },
                {
                    Name: "06"
                },
                {
                    Name: "07"
                },
                {
                    Name: "08"
                },
                {
                    Name: "09"
                },
                {
                    Name: "10"
                },
                {
                    Name: "11"
                },
                {
                    Name: "12"
                },
                {
                    Name: "13"
                },
                {
                    Name: "14"
                },
                {
                    Name: "15"
                },
                {
                    Name: "16"
                },
                {
                    Name: "17"
                },
                {
                    Name: "18"
                },
                {
                    Name: "19"
                },
                {
                    Name: "20"
                },
                {
                    Name: "21"
                },
                {
                    Name: "22"
                },
                {
                    Name: "23"
                }
            ]

            $scope.MinuteArray = [
                {
                    Name: "00"
                },
                {
                    Name: "01"
                },
                {
                    Name: "02"
                },
                {
                    Name: "03"
                },
                {
                    Name: "04"
                },
                {
                    Name: "05"
                },
                {
                    Name: "06"
                },
                {
                    Name: "07"
                },
                {
                    Name: "08"
                },
                {
                    Name: "09"
                },
                {
                    Name: "10"
                },
                {
                    Name: "11"
                },
                {
                    Name: "12"
                },
                {
                    Name: "13"
                },
                {
                    Name: "14"
                },
                {
                    Name: "15"
                },
                {
                    Name: "16"
                },
                {
                    Name: "17"
                },
                {
                    Name: "18"
                },
                {
                    Name: "19"
                },
                {
                    Name: "20"
                },
                {
                    Name: "21"
                },
                {
                    Name: "22"
                },
                {
                    Name: "23"
                },
                {
                    Name: "24"
                },
                {
                    Name: "25"
                },
                {
                    Name: "26"
                },
                {
                    Name: "27"
                },
                {
                    Name: "28"
                },
                {
                    Name: "29"
                },
                {
                    Name: "30"
                },
                {
                    Name: "31"
                },
                {
                    Name: "32"
                },
                {
                    Name: "33"
                },
                {
                    Name: "34"
                },
                {
                    Name: "35"
                },
                {
                    Name: "36"
                },
                {
                    Name: "37"
                },
                {
                    Name: "38"
                },
                {
                    Name: "39"
                },
                {
                    Name: "40"
                },
                {
                    Name: "41"
                },
                {
                    Name: "42"
                },
                {
                    Name: "43"
                },
                {
                    Name: "44"
                },
                {
                    Name: "45"
                },
                {
                    Name: "46"
                },
                {
                    Name: "47"
                },
                {
                    Name: "48"
                },
                {
                    Name: "49"
                },
                {
                    Name: "50"
                },
                {
                    Name: "51"
                },
                {
                    Name: "52"
                },
                {
                    Name: "53"
                },
                {
                    Name: "54"
                },
                {
                    Name: "55"
                },
                {
                    Name: "56"
                },
                {
                    Name: "57"
                },
                {
                    Name: "58"
                },
                {
                    Name: "59"
                }
            ]

            $scope.splitLinkQty = function (linkData, row, index) {
                if (!row.SplitQty > 0) {
                    toastr.warning("Split Quantity Not Found!");
                } else if (row.SplitQty > row.BalanceQty) {
                    toastr.warning("Split Quantity Invalid!");
                } else {

                    var newrow = angular.copy(row);
                    newrow.Quantity = row.SplitQty;
                    newrow.SplitQty = 0;
                    newrow.BalanceQty = newrow.Quantity;
                    newrow.QtyToLink = newrow.Quantity;
                    linkData.CommonVoucherDetails.push(newrow);

                    row.BalanceQty = row.BalanceQty - row.SplitQty;
                    row.SplitQty = 0;
                    //row.Quantity = row.Quantity;
                    // row.QtyToLink = row.Quantity;
                    row.QtyToLink = row.BalanceQty;
                }
            }

            $scope.chooseDateRange = function (data) {

                if (data.DateRange == "Today") {
                    data.FromDate = new Date();
                    data.ToDate = new Date();
                } else if (data.DateRange == "This Week") {

                    var d = new Date();
                    d.setDate(d.getDate() - 6);

                    data.FromDate = d;
                    data.ToDate = new Date();
                } else if (data.DateRange == "This Month") {

                    var date = new Date(),
                        y = date.getFullYear(),
                        m = date.getMonth();
                    var firstDay = new Date(y, m, 1);
                    data.FromDate = firstDay;
                    data.ToDate = new Date();

                } else if (data.DateRange == "Last Month") {

                    var d1 = new Date();

                    d1.setMonth(d1.getMonth() - 2);

                    var lastDay = new Date(d1.getFullYear(), d1.getMonth() + 1, 0);

                    data.FromDate = d1;
                    data.ToDate = lastDay;

                } else if (data.DateRange == "Last 2 Months") {

                    var d1 = new Date();
                    d1.setMonth(d1.getMonth() - 2);

                    data.FromDate = d1;
                    data.ToDate = new Date();
                } else if (data.DateRange == "Last 3 Months") {

                    var d1 = new Date();
                    d1.setMonth(d1.getMonth() - 3);

                    data.FromDate = d1;
                    data.ToDate = new Date();
                } else if (data.DateRange == "Last 6 Months") {

                    var d1 = new Date();
                    d1.setMonth(d1.getMonth() - 6);

                    data.FromDate = d1;
                    data.ToDate = new Date();
                } else if (data.DateRange == "This Year") {
                    var date = new Date();
                    var y = date.getFullYear();
                    var firstDay = new Date(y, 0, 1);

                    data.FromDate = firstDay;
                    data.ToDate = new Date();
                } else if (data.DateRange == "Last Year") {

                    var date = new Date();
                    var y = date.getFullYear() - 1;
                    var firstDay = new Date(y, 0, 1);
                    var lastDay = new Date(y, 11, 31);

                    data.FromDate = firstDay;
                    data.ToDate = lastDay;
                }
            }

            $scope.tableVisible = true;
            $scope.reloadTable = function (cb) {
                $scope.tableVisible = false;
                $timeout(function () {
                    $scope.tableVisible = true;

                    $timeout(function () {
                        // Apply callback after the rerender
                        cb()
                    })
                });
            };

            // Function to rearrange table cells
            $scope.rearrangeTableCells = function (order) {
                $scope.reloadTable(function () {

                    //var table = angular.element(document.getElementById("rearrangeTable"));
                    // Select all rows in the table (including the header)
                    var table = document.getElementById("rearrangeTable")
                    var rows = table.querySelectorAll('tr');

                    rows.forEach(function (row) {
                        // Create an array to hold the cells in the new order
                        var newCells = [];

                        // Iterate through the order array and push the corresponding cells
                        order.forEach(function (key) {
                            var cell = row.querySelector('[data-key="' + key + '"]');
                            if (cell) {
                                newCells.push(cell);
                            }
                        });

                        // Clear the current row content
                        while (row.firstChild) {
                            row.removeChild(row.firstChild);
                        }

                        // Append the cells in the new order
                        newCells.forEach(function (cell) {
                            row.appendChild(cell);
                        });
                    });
                })
            }

            $scope.OpenVoucherLinkHistory = function (id) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetVoucherLinkHistory(id).then(function (response) {
                    $scope.load = false;
                    if (response.data != null) {
                        var arr = [];
                        arr.push(response.data)
                        console.log("GetVoucherLinkHistory", response.data)
                        $scope.linkHistoryVouchers = convertToNodes(response.data);
                        $('#linkHistoryModal').modal('show');
                    } else {
                        toastr.warning("No Data Found");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });

            }
            // Helper function to format date as 'DD/MM/YYYY'
            function formatDate(dateString) {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return day + "/" + month + "/" + year;
            };

            function convertToNodes(node) {
                if (!node) return null;

                return {
                    name: node.ChildVoucherNo,
                    attributes: {
                        Date: formatDate(node.Date),
                        Voucher: node.ChildVoucher
                    },
                    children: (node.Children || []).map(convertToNodes)
                };
            }

            $scope.OpenRecurrenceModal = function (vdata, VName) {

                var voucher = angular.copy(vdata);
                voucher.Id = 0;
                $scope.recurrence = {
                    VoucherData: voucher,
                    VoucherName: VName,
                    DayType: "Date Wise",
                    Date: 0,
                    DayOn: "Date Wise",
                    Day: "",
                    Interval: 1,
                    FromDate: new Date(),
                    ToDate: new Date(),
                }

                var aYearFromNow = new Date();
                aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);

                $scope.recurrence.ToDate = aYearFromNow;

                $('#recurrenceModal').modal('show');
            }

            $scope.SaveRecurrence = function () {

                if ($scope.recurrence.RecType == "Monthly" && $scope.recurrence.DayType == "Date Wise" && $scope.recurrence.Date == 0) {
                    toastr.warning("Enter Date On");
                } else if ($scope.recurrence.DayType == "Day Wise" && $scope.recurrence.DayOn == "") {
                    toastr.warning("Choose Day On");
                } else if ($scope.recurrence.DayType == "Day Wise" && $scope.recurrence.Day == "") {
                    toastr.warning("Choose Day");
                } else if (($scope.recurrence.DayType == "Day Wise" || $scope.recurrence.DayType == "Date Wise") && $scope.recurrence.Interval <= 0) {
                    toastr.warning("Enter Interval");
                } else if ($scope.recurrence.RecType == "Weekly" && $scope.recurrence.Day == "") {
                    toastr.warning("Choose Day");
                } else if ($scope.recurrence.RecType == "Weekly" && $scope.recurrence.Interval <= 0) {
                    toastr.warning("Enter Interval");
                } else {

                    var result = [];

                    if ($scope.recurrence.RecType == "Monthly") {

                        if ($scope.recurrence.DayType == "Date Wise") {

                            var start = new Date($scope.recurrence.FromDate);
                            var end = new Date($scope.recurrence.ToDate);

                            while (start <= end) {
                                var year = start.getFullYear();
                                var month = start.getMonth();

                                // Ensure the day is valid for the month (e.g., handle February 30)
                                var date = new Date(year, month, $scope.recurrence.Date);
                                if (date.getMonth() !== month) {
                                    // If the day exceeds the max days in the month, set to last day
                                    date = new Date(year, month + 1, 0);
                                }

                                if (date >= new Date($scope.recurrence.FromDate) && date <= new Date($scope.recurrence.ToDate)) {
                                    result.push(date);
                                }

                                // Move to the next month
                                start.setMonth(start.getMonth() + 1);
                            }

                            console.log(result);


                        }

                        if ($scope.recurrence.DayType == "Day Wise" && $scope.recurrence.DayOn == "First") {

                            var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                            var start = new Date($scope.recurrence.FromDate);
                            var end = new Date($scope.recurrence.ToDate);
                            var targetDay = daysOfWeek.indexOf($scope.recurrence.Day);;

                            var count = 0;

                            while (start <= end) {
                                var year = start.getFullYear();
                                var month = start.getMonth();

                                // Ensure the day is valid for the month (e.g., handle February 30)
                                var firstDay = new Date(year, month, 1);
                                var firstTargetDay = new Date(year, month, 1 + ((targetDay - firstDay.getDay() + 7) % 7)); // Calculate first occurrence

                                if (firstTargetDay >= new Date($scope.recurrence.FromDate) && firstTargetDay <= new Date($scope.recurrence.ToDate)) {
                                    if (count % $scope.recurrence.Interval === 0) {
                                        result.push(firstTargetDay); // Format as YYYY-MM-DD
                                    }
                                    count++;
                                }

                                // Move to the next month
                                start.setMonth(start.getMonth() + 1);

                            }

                            console.log(result);


                        }

                        if ($scope.recurrence.DayType == "Day Wise" && $scope.recurrence.DayOn == "Last") {

                            var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                            var start = new Date($scope.recurrence.FromDate);
                            var end = new Date($scope.recurrence.ToDate);
                            var targetDay = daysOfWeek.indexOf($scope.recurrence.Day);;

                            var count = 0;

                            while (start <= end) {
                                var year = start.getFullYear();
                                var month = start.getMonth();

                                // Ensure the day is valid for the month (e.g., handle February 30)
                                var lastDayOfMonth = new Date(year, month + 1, 0);
                                var lastTargetDay = new Date(lastDayOfMonth);


                                while (lastTargetDay.getDay() !== targetDay) {
                                    lastTargetDay.setDate(lastTargetDay.getDate() - 1);
                                }

                                if (lastTargetDay >= new Date($scope.recurrence.FromDate) && lastTargetDay <= new Date($scope.recurrence.ToDate)) {
                                    if (count % $scope.recurrence.Interval === 0) {
                                        result.push(lastTargetDay); // Format as YYYY-MM-DD
                                    }
                                    count++;
                                }


                                // Move to the next month
                                start.setMonth(start.getMonth() + 1);
                                start.setDate(1);

                            }

                            console.log(result);


                        }

                    }

                    if ($scope.recurrence.RecType == "Weekly") {

                        var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                        var start = new Date($scope.recurrence.FromDate);
                        var end = new Date($scope.recurrence.ToDate);
                        var targetDay = daysOfWeek.indexOf($scope.recurrence.Day);;

                        while (start.getDay() !== targetDay) {
                            start.setDate(start.getDate() + 1);
                        }

                        var count = 0;
                        // Collect all occurrences of the target day within the date range
                        while (start <= end) {
                            if (count % $scope.recurrence.Interval === 0) {
                                var temp = angular.copy(new Date(start));
                                result.push(temp);
                            }
                            count++;
                            start.setDate(start.getDate() + 7);
                        }

                        console.log(result);


                    }

                    if ($scope.recurrence.RecType == "Once") {
                        result.push($scope.recurrence.FromDate);
                        console.log(result);
                    }

                    if ($scope.recurrence.RecType == "Daily") {
                        var start = new Date($scope.recurrence.FromDate);
                        var end = new Date($scope.recurrence.ToDate);

                        while (start <= end) {
                            result.push(start); // Format as YYYY-MM-DD
                            start.setDate(start.getDate() + $scope.recurrence.Interval); // Move forward by interval days
                        }

                        console.log(result);

                    }





                    var tt = 1;
                    var ttt = 0;

                    $scope.processRecurrence(result, tt, ttt);

                    //                    angular.forEach(result, function (e) {
                    //                    })



                }



            }


            $scope.processRecurrence = function (result, tt, ttt) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                var dateTemp = $scope.extractDate(result[ttt]);
                $scope.recurrence.VoucherData.DateString = dateTemp;

                RecurrenceService.SaveRecurrence($scope.recurrence).then(function (response) {
                    if (response.data) {


                        if (result.length == tt) {
                            $scope.Load = false;
                            toastr.success("Success");
                            $scope.recurrence = {};
                            $('#recurrenceModal').modal('hide');
                        } else {

                            tt = tt + 1;
                            ttt = ttt + 1;

                            $scope.processRecurrence(result, tt, ttt);
                        }



                    } else {
                        $scope.Load = false;
                        toastr.warning("Failed");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });

            }


            $scope.convertNo = function (data) {
                var rounded = function (num, decimals) {
                    return parseFloat(num.toFixed(decimals || 0));
                };

                if (data >= 1000000) {
                    return rounded(data / 1000000, 1) + " million";
                } else if (data >= 100000) {
                    return rounded(data / 100000, 1) + " hundred thousand";
                } else if (data >= 1000) {
                    return rounded(data / 1000, 1) + " thousand";
                } else if (data >= 100) {
                    return rounded(data / 100, 1) + " hundred";
                } else {
                    return data.toString();
                }
            };


            $scope.SendMail = function (data, Type, Title) {
                AppReactLib.emailSender.RenderEmailSenderModal({
                    entityId: data.Id,
                    entityType: Type,
                    title: Title,
                    onSuccess: (result) => {
                        console.log("Modal Success:", result);
                    },
                    onError: (error) => {
                        console.log("Modal Error:", error);
                    },
                    onClose: () => {
                        console.log("Modal closed");
                    },
                });
            };

            $scope.roundOffValue = function (val) {

                if ($scope.CompanyProfile.RoundOff == 2) {
                    val = Math.round(val * 100) / 100;
                    return val;
                }
                else if ($scope.CompanyProfile.RoundOff == 3) {
                    val = Math.round(val * 1000) / 1000;
                    return val;
                }
                else if ($scope.CompanyProfile.RoundOff == 4) {
                    val = Math.round(val * 10000) / 10000;
                    return val;
                }
                else if ($scope.CompanyProfile.RoundOff == 5) {
                    val = Math.round(val * 100000) / 100000;
                    return val;
                }
                else if ($scope.CompanyProfile.RoundOff == 6) {
                    val = Math.round(val * 1000000) / 1000000;
                    return val;
                }
                else if ($scope.CompanyProfile.RoundOff == 7) {
                    val = Math.round(val * 1000001000000000) / 10000000;
                    return val;
                }
                else if ($scope.CompanyProfile.RoundOff == 8) {
                    val = Math.round(val * 100000000) / 100000000;
                    return val;
                }
                else if ($scope.CompanyProfile.RoundOff == 9) {
                    val = Math.round(val * 10000000000) / 10000000000;
                    return val;
                }
                else if ($scope.CompanyProfile.RoundOff == 10) {
                    val = Math.round(val * 10000000000) / 10000000000;
                    return val;
                }
                else {
                    val = Math.round(val * 100) / 100;
                    return val;
                }



            }

        }]);
